<template>
  <div class="protocol">
    <template v-if="!dataSource.readonly">
      <!-- 个人-租赁协议 -->
      <template v-if="type == 1">
        <img
        src="@/assets/images/1.png"
      /></template>
      <!-- 个人-购买协议 -->
      <template v-else-if="type == 2">
        <img
        src="@/assets/images/2.png"
      /></template>
    <template v-else-if="type == 3">
        <h1>侨行天下用户使用协议</h1>
        <p>
          重要提示：<br />本服务协议为牦牛信息科技（杭州）有限公司（以下称“本公司”）与您签订。在您通过本公司系统（本公司系统：官网www.qiaoxingtx.com，手机端：侨行天下APP）注册成为本公司的用户前请务必仔细阅读以下条款。若您完成本公司系统指定的注册流程，则表示您同意接受本公司的服务并受以下条款的约束。若您不接受以下条款，请您立即停止注册或使用本公司的服务。
        </p>
        <p>
          第一章 特别提醒<br />第一条
          本公司只接受持有中国（不含港澳台地区）有效身份证明的18周岁以上具有完全民事行为能力的自然人成为注册用户。如您不符合资格，请勿注册，否则本公司有权随时中止或终止您的用户资格，因此所导致的任何后果甶您个人承担。<br />第二条
          本协议内容包括以下条款及本公司系统上已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的一部分，与协议正文具有同等法律效力。<br />第三条
          本公司有权根据需要不时地修改本协议或根据本协议制定、修改各类具体规则并在本公司相关系统板块上发布，无需另行单独通知您。<br />(1)如您不同意变更后的协议及相关规则内容，应立即停止通过本公司系统进行所有交易。<br />(2)若您在本协议及具体规则内容公告变更后继续使用本公司服务的，表示您已充分阅读、理解并接受修改后的协议和具体规则内容；同时就您在协议和具体规则修订前通过本公司系统进行的交易及其效力，视为您已同意并已按照本协议及有关规则进行了相应的授权和追认。<br />第四条在您注册成为用户时，您已经阅读、理解并接受本协议的全部条款及各类规则，如有违反而导致任何法律后果的发生，您将以自己的名义独立承担相应的法律责任。<br />第五条您同意以网络页面点击确认的方式签署本协议，并不以此为由拒绝履行本协议及协议下的规则上约定的义务。在您点击确认本协议后，本协议即在您和本公司之间产生法律效力。
        </p>
        <p>
          第二章 风险告知<br />您作为注册用户使用本公司系统时，已知悉通过本公司系统进行相关交易可能存在诸多风险，包括但不限于以下风险：<br />第一条
          政策风险<br />甶于国家法律、法规、政策的变化，紧急措施的出台，相关监管部门监管措施的实施，交易所交易规则的修改等原因，均可能会对您的交易产生影响，您必须承担由此导致的损失。<br />第二条
          黄金价格波动风险<br />黄金价格受多种因素的影响（如国际经济形势、美元汇率、相关市场走势、政治局势、原油价格等等），这些因素对金价的影响机制非常复杂，如果不能有效控制风险，则可能遭受损失。<br />第三条
          技术风险<br />本公司所提供的服务系通过电子通讯技术和互联网技术来实现。可能会存在品质和稳定性方面的风险，通讯或网络故障导致的某些服务中断或延时，另外您的电脑系统或手机APP端也可能会甶于网络信息或者病毒或网络黑客攻击等不确定因素，有可能会给您的交易带来一定影响。<br />第四条
          不可抗力风险<br />本公司提供的服务在遇到地震、水灾、火灾、暴动、罢工、战争、政府管制、国内外的禁止或限制以及停电、技术故障、电子故障等其他无法预测和防范的不可抗力事件时，都有可能会对您的交易产生影响或造成其损失。
        </p>
        <p>
          第三章 用户信息及账户安全<br />第一条 用户注册及验证<br />(1)您在本公司的注册采用实名认证，您应保证提供的姓名、联系电话、联系地址、电子邮件地址等内容的真实性、安全性和有效完整性，以便本公司为您提供服务时能及时与您取得联系。<br />(2)您同意本公司自行或通过合作的第三方机构对您提交或本公司搜集的用户信息（包括但不限于您的个人身份证信息等）进行核实，并对获得的核实结果根据本协议及有关文件进行查看、使用和留存等操作。若甶于您信息不真实、完整的，我公司有权暂停或终止您的注册申请。<br />(3)若您的信息变更的，应及时联系侨行天下客服（客服电话:400-022-1010)及时办理变更手续。<br />若甶于您未能及时更新个人信息导致本公司为您提供的服务过程中遭受损失或增加费用等的，甶您本人承担相应的不利后果;若由此给我公司及其他关联公司造成损失的，您应承担相应的赔偿责任。<br />第二条
          账户安全<br />(1)您的账号仅限本人使用，不可转让及赠送。您确认，无论是您还是您的代理人，用您的用户名和密码登录本公司系统后在本公司的一切行为均代表您并由您承担相应的法律后果。<br />(2)您有义务保管好账号、密码等个人信息：<br />若您发现有第三人冒用或盗用您的用户账户及密码，或其他任何未经合法授权的情形，应立即通知本公司，要求本公司暂停相关服务，否则由此产生的一切责任由您本人承担。<br />(3)您须仔细甄别确认为本公司的系统后再登陆，因您不慎误登录钓鱼网站等非正规网站而导致的经济损失，由您自行承担。<br />第三条
          隐私保护<br />（1）您同意并授权本公司将您的包括但不限于真实姓名、联系方式等必要的个人信息和交易信息披露给与您交易的另一方或本公司的合作机构（仅限于本公司为完成拟向您提供的服务而合作的机构）。<br />（2）本公司有义务根据有关法律要求向司法机关和政府部门提供您的个人资料。<br />（3）您同意接收本公司以电子邮件或短信形式向其手机（手机号码、邮件地址）发布促销等信息（接收短信不收取任何费用。<br />（4）本公司对于您提供的、自行收集到的、经认证的个人信息将按照本协议及有关规则予以保护、使用或者披露。本公司将保护您的个人资料，但鉴于技术限制，本公司不能确保您的全部私人通讯及其他个人资料不被相关方以其他方式获取。
        </p>
        <p>
          第四章 提供的服务<br />第一条
          本公司提供的服务包括但不限于：黄金报价、黄金实物的购买、黄金实物的提取、饰品换购、黄金的回收等，具体详情以本公司当时提供的服务内容为准。<br />第二条
          基于运行和交易安全的需要，本公司可暂时停止提供、限制或改变本公司服务的部分功能，或提供新的功能。在任何功能变化时，只要您仍然使用本公司提供的服务，表示您同意本协议或变更后的协议。<br />第三条
          您在本公司系统上按相应的服务流程所确认的交易状态将成为本公司为您进行相关交易或操作（包括但不限于冻结资金、代为支付或收取款项、订立合同等）的明确指令。您同意本公司有权按相关指令依据本协议和/或有关文件和规则对相关事项进行处理。<br />第四条
          您未能及时对交易状态进行修改或确认或未能提交相关申请所引起的任何纠纷或损失甶您本人负责，本公司不承担任何责任。
        </p>
        <p>
          第五章 实物黄金交易及费用<br />第一条
          在本公司系统上，您可以提交“实物黄金购买”订单、提交“实物黄金回收”订单、实物黄金提取、申请换购、以旧换新等业务，其他业务的开通以本公司公告为准，具体的操作规则请见相关页面的规则和说明。<br />第二条
          在为您提供上述服务时，可能会收取相应的服务费用，具体内容请参照有关文件及本公司系统上相关页面的规则和说明。同时，本公司有权不时调整前述服务或管理费用的类型或金额等具体事项并根据本协议和相关规则进行公告、修改。
        </p>
        <p>
          第六章 实物黄金购买、提取与换购<br />第一条
          本公司所销售的实物黄金产品，可接受您的直接购买，也可使用在本公司购买的实物黄金进行换购；<br />换购的或线上提货的产品：本公司有权根据实物黄金产品库存及订单情况，规定在特定时间内可供出售或可交割、换购的实物黄金产品限额。<br />第二条
          本公司所提供的实物黄金产品的纯度、规格、款式等信息详见公司系统上相关产品介绍页面。<br />第三条
          您在本公司系统上指定的提货点提货进行或选择快递提金，具体按照页面上可选定的操作。
        </p>
        <p>
          第七章 货品运输及退换货<br />第一条
          在您购买、交割或换购实物黄金产品交易完成后，因原料环节、生产环节、物流环节或其他非本公司主观原因导致您无法按本公司系统上声明的规定时间收到实物黄金产品的，本公司不承担相关责任。<br />第二条
          本公司所有实物黄金产品通过系统规定的方式发送至您选定的提货门店，包括但不限于快递、普通邮寄等。本公司所有实物黄金产品的发送均向保险公司投保，以保障您的财产安全;您选定的门店在收到货品后会第一时间通知您取货，请您及时去提取货品，并与门店进行核验。如您对货品产生疑问的，请当场拒收。<br />第三条
          本公司所有实物黄金产品一经签收不接受无偿退货。(由于实物黄金产品的特殊性，请您在货签收时确认，本产品一经签署不适用无理由退货）。
        </p>
        <p>
          第八章 资金管理<br />第一条
          就您在本公司系统上进行的实物黄金交易或实物黄金产品购买，本公司委托的第三方机构将为您提供“资金管理服务”，主要包括但不限于：资金的充值、提现、代收、代付、查询等。您可以通过本公司系统的有关页面的具体规则或说明详细了解。<br />第二条
          您已知悉，上述资金充值、提现、代收、代付以及查询等服务涉及本公司与第三方支付机构或金融机构的合作，并对下述事项予以认可：（a)受第三方支付机构或金融机构可能仅在工作日进行资金代扣及划转的现状等各种原因所限，本公司不对前述服务的资金到账时间做任何承诺，也不承担与此相关的责任，包括但不限于由此产生的利息、货币贬值等损失；（b)—经您使用前述服务，即表示您不可撤销地授权本公司进行相关操作，且该等操作是不可逆转的，您不能以任何理由拒绝付款或要求取消交易。就前述服务，您应按照有关文件及第三方支付机构或金融机构的规定支付第三方的费用，您与第三方之间就费用支付事项产生的争议或纠纷，与本公司无关。<br />第三条
          您保证并承诺您用于参与本公司相关交易的资金来源的合法和实物黄金来源的合法且不会受到任何其他方的权利追索。您同意，本公司有权按照包括但不限于公安机关、检察机关、<br />法院等司法机关、行政机关、军事机关的要求协助对您的账户及资金等进行查询、冻结或扣划等操作。<br />第四条
          如果本公司发现了因系统故障或其他原因导致的处理错误，无论有利于本公司还是有利于您，本公司有权在根据本协议规定通知您后纠正该错误。您理解并同意，本公司不承担因前述处理错误而导致的任何损失或责任（包括您可能因前述错误导致的收益等损失），但因本公司恶意或重大过失而导致的处理错误除外。
        </p>
        <p>
          第九章 免责条款<br />第一条
          您同意，本公司不能保证也没有义务保证第三方网站上的信息的真实性、准确性和有效性。您应按照第三方网站的服务协议使用第三方网站，而不是按照本协议。第三方网站的内容、产品、广告和其他任何信息均甶您自行判断并承担风险，而与本公司无关。<br />第二条
          鉴于技术及设备的局限性，因为本公司或者涉及的第三方网站的设备、系统存在缺陷、被黑客攻击、出现网络故障、<br />电力中断、计算机病毒或其他不可抗力因素造成的损失，本公司不承担相应的赔偿责任，您可以与本公司协商终止本协议并停止使用本公司系统。但是，中国现行法律、法规另有规定的除外。<br />第三条
          在任何情况下，对于您使用本公司服务过程中涉及由第三方提供相关服务的责任由该第三方承担，本公司不承担该等责任。因您自身的原因导致本公司服务无法提供或提供时发生任何错误而产生的任何损失或责任，甶您自行负责，本公司不承担责任。
        </p>
        <p>
          第十章 使用限制<br />第一条
          您承诺合法使用本公司提供的服务及内容。您不得利用本公司系统从事侵害他人合法权益的行为、或违法违规之行为、或任何未经授权的行为等。<br />第二条
          由于您违反本协议或法律、法规或侵害第三方的权利，而引起第三方对本公司提出的任何形式的索赔、权利主张或要求、诉讼，本公司有权向您追偿相关的直接损失或间接损失，包括但不限于本公司因此支付的法律服务等中介费用、名誉损失、及向第三方支付的补偿金、损害赔偿金等。
        </p>
        <p>
          第十一章 协议终止及账户的暂停、注销或终止<br />第一条
          除非本公司终止本协议或者您申请终止本协议且经本公司同意，否则本协议始终有效。<br />第二条
          您决定不再使用用户账户时，应首先清偿所有应付款项（包括但不限于服务费、管理费等），再将用户账户中的可用款项（如有）全部提现或者向公司系统发出其它合法的支付指令，并向本公司申请注销该用户账户，经本公司审核同意后可正式注销用户账户。<br />注册会员死亡或被宣告死亡的，其在本协议项下的各项权利义务由其继承人承担。若注册会员丧失全部或部分民事权利能力或民事行为能力，本公司有权根据有效法律文书（包括但不限于生效的法院判决等）或其法定监护人的指示处置与用户账户相关的款项。<br />第三条
          如发生如下情形的，您认可，本公司有权基于单方独立判断在认为可能发生危害交易安全等情形时，可先行暂停、中断或终止向您提供本协议项下的全部或部分服务，且无需对您或任何第三方承担任何责任。前述情形包括但不限于：<br />（1）本公司认为您提供的个人资料不具有真实性、有效性或完整性；<br />（2）您使用本公司服务的行为涉嫌违反国家法律法规及行政规定的；<br />（3）本公司发现异常交易或有疑义或有违法之虞时；<br />（4）本公司认为您的账户涉嫌洗钱、套现、传销、被冒用或其他本公司认为有风险之情形；或认为账户操作、黄金现货、资金进出等存在异常时；<br />（5）本公司收到有权机关的要求；<br />（6）您受到第三方的投诉，且对方已经提供了一定证据的；<br />（7）本公司认为您已经违反本协议之内容；<br />（8）本公司基于交易安全等原因，需先行暂停、中断或终止向您提供本协议项下的全部或部分会员服务，并将注册资料移除或删除的其他情形。<br />（9）在您违反了本协议及相关规则，或在相关法律法规、政府部门的要求下，本公司有权通过电子邮件通知或短信的等方式终止本协议、关闭您的账户或者限制您使用本公司系统。但本公司的终止行为不能免除您根据本协议或在本公司系统上生成的其他协议项下的还未履行完毕的义务。<br />第四条
          您同意，在必要时，本公司无需进行事先通知即有权终止提供用户账户服务，并可能立即暂停、关闭或删除您的用户账户及该用户账户中的所有相关资料及档案，并将您滞留在这些<br />账户的全部合法资金退回到您的银行账户。<br />第五条
          您同意，用户账户的暂停、中断或终止不代表您在本协议项下及本公司相关交易行为中责任和义务的终止，您仍应对您使用本公司系统服务期间的行为承担可能的违约或损害赔偿责任，同时本公司仍可保有您的相关信息。
        </p>
        <p>
          第十二章 协议生效及变更<br />第一条
          在不损害您利益的前提下，本公司保留修改或增补本协议内容的权利。本协议的修改文本将由本公司通过与业务内容相适应的方式进行公告或以其他本公司认为可行的方式通知。<br />第二条
          本协议书生效后，若有关法律法规或其他本公司和您应共同遵守的法律依据发生修订，本协议与之不相适应的内容及条款自行失效，但本协议其他内容和条款继续有效。
        </p>
        <p>
          第十三章 通知及送达条款<br />本协议项下的通知如以公示方式作出，一经在本公司系统上公示即视为已经送达。除此之外，其他向您个人发布的具有专属性的通知将由本公司向您在注册时提供的电子邮箱，或您在注册后绑定的手机发送，一经发送即视为已经送达。您同时同意并确认，若您设置了不接收有关通知或提醒，则您有可能无法收到该等通知信息，您不得以您未收到或未阅读该等通知信息主张相关通知未送达于您。
        </p>
        <p>
          第十四章 适用法律和争议解决<br />本协议之效力、解释、变更、执行与因本公司所提供服务而产生的争议均适用中国法律，并由将争议提交杭州市仲裁委员会，依据该会届时有效的仲裁规则进行仲裁。仲裁裁决是终局裁决，对双方均有强制执行力。仲裁期间，本协议不涉及争议的条款应继续履行。
        </p>
        <p>
          第十五章 其他<br />在法律法规允许的范围内，本公司对本协议享有修改权和最终解释权。本协议及本公司系统有关页面的相关名词可互相引用参照，如有不同理解，则以本协议条款为准。此外，若本协议的部分条款被认定为无效或者无法实施时，本协议中的其他条款仍效有效。
        </p>
        <p>
          第十六章 名词定义<br />实物黄金或实物黄金产品：是指本公司系统上所销售的实物黄金产品，包括但不限于金币、金条、黄金饰品等产品。<br />用户：是指向本公司系统进行交易的有民事主体资格的自然人（须在本公司系统上注册并通过实名认证并绑定银行卡）。
        </p>
      </template>
      <template v-else-if="type == 4">
        <h1>隐私政策</h1>
        <h3>本隐私政策于2020年1月25发布并生效</h3>
        <p>前言：</p>
        <p>
          牦牛信息科技（杭州）有限公司及旗下软件或各关联公司（以下统称&ldquo;牦牛&rdquo;或&rdquo;侨行天下&rdquo;或&ldquo;我们&rdquo;）一向庄严承诺保护使用牦牛的产品和服务（以下统称&ldquo;牦牛服务&rdquo;或&ldquo;侨行天下服务&rdquo;或&ldquo;我们的服务&rdquo;）之用户（以下统称&ldquo;用户&rdquo;或&ldquo;您&rdquo;）的隐私。您在使用牦牛服务时，我们可能会收集和使用您的相关信息。
        </p>
        <p>
          本《隐私政策》适用于我们提供的一切牦牛服务。当您使用我们任何单项服务时，您同意接受本《隐私政策》以及我们在该单项服务中发出的特定隐私信息类政策条款（下列称&ldquo;特定条款&rdquo;）的保护，在此情况下特定条款与本政策条款同时对您产生效力。
        </p>
        <p>
          请注意我们不时地会检查我们的政策，因此有关的措施会随之变化。我们恳请您定期光顾本页面，以确保对我们《隐私政策》最新版本始终保持了解。当我们的隐私政策发生变化时，我们会在APP启动时以弹窗页面告知用户隐私政策已作更新，并提供入口到更新后的隐私政策页面。
        </p>
        <p>一、我们可能收集的信息</p>
        <p>（一）与个人身份无关的信息：</p>
        <p>
          当您使用我们的服务时，我们可能收集和汇总诸如用户的来源途径、访问顺序等信息，例如记录使用我们的服务的每个用户的来源途径、浏览器软件等。
        </p>
        <p>（二）有关个人身份的信息：</p>
        <p>
          当您使用我们的服务时，我们可能收集和汇总或要求您提供有关个人身份的信息，例如<strong
            ><strong>个人身份证明</strong></strong
          >（包括身份证、护照、驾驶证等）；<strong
            ><strong
              >生日、籍贯、性别、个人电话号码；网络身份标识信息（包括系统账号、IP地址、电子邮箱地址及与前述有关的密码、口令、口令保护答案）；个人财产信息（交易记录、余额、优惠券、银行卡信息）；通讯信息；个人上网记录和日志信息（包括网站浏览记录、软件使用记录、点击记录、操作日志）；设备信息（包括设备型号、设备MAC地址、操作系统类型、设备设置）；软件列表唯一设备识别码（如IMEI/android
              ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息）；位置信息（包括行程信息、精准定位信息、住宿信息、经纬度）</strong
            ></strong
          >。
        </p>
        <p>
          我们收集您的信息主要是为了您和其他用户能够更容易和更满意地使用我们的服务。我们的目标是向所有的互联网用户提供安全、刺激、有趣及有教益的上网经历。而这些信息有助于我们实现这一目标。
        </p>
        <p>
          请注意，如您在我们的服务中其他用户可见的公开区域内上传或发布的信息中、您对其他人上传或发布的信息作出的回应中公开您的个人信息，该等信息可能会被他人收集并加以使用。
        </p>
        <p>二、我们如何收集和使用信息</p>
        <p>（一）我们将通过以下途径收集和获得您的信息：</p>
        <p>1、您提供的信息。 例如：</p>
        <p>
          （1）您在注册我们的服务的帐号或使用我们的服务时，向我们提供的信息；
        </p>
        <p>
          （2）您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。
        </p>
        <p>
          2、其他方分享的您的信息。亦即其他方使用我们的服务时所提供有关您的共享信息。
        </p>
        <p>
          3、我们获取的您的信息。您在使用我们的服务时，我们收集、汇总、记录的信息，例如日志信息、位置信息、设备信息等。
        </p>
        <p>收集、汇总、记录的信息相关用途</p>
        <p>
          <strong><strong>手机储存用于下载app，上传头像</strong></strong>
        </p>
        <p>
          <strong><strong>电话用于拨打客服电话</strong></strong>
        </p>
        <p>
          <strong><strong>相机用于上传或更换头像</strong></strong>
        </p>
        <p>
          <strong><strong>日志信息用于对接的三方服务</strong></strong>
        </p>
        <p>
          <strong><strong>位置信息用于对接的三方服务</strong></strong>
        </p>
        <p>
          <strong><strong>设备信息用于对接的三方服务</strong></strong>
        </p>
        <p>（二）我们会出于以下目的，收集和使用您的信息：</p>
        <p>
          1、<strong><strong>帮助您完成注册</strong></strong>
        </p>
        <p>
          为便于我们为您提供服务，您需要提供基本注册信息，例如手机号码、电子邮箱地址等，并创建您的用户名和密码。在部分单项服务中，如果您仅需使用浏览、搜索等基本服务，您不需要注册成为我们的用户及提供上述信息。
        </p>
        <p>
          2、<strong><strong>向您提供商品或服务</strong></strong>
        </p>
        <p>
          我们所收集和使用的信息是为您提供我们的服务的必要条件，如缺少相关信息，我们将无法为您提供我们的服务的核心内容，例如：
        </p>
        <p>
          （1）在部分服务项目中，为便于向您交付商品或服务，您需提供收货人个人身份信息、姓名、收货地址、邮政编码、收货人、联系电话、支付状态等信息。如果您拒绝提供此类信息，我们将无法完成相关交付服务。如您通过我们的服务为其他人订购商品或服务，您需要提供该实际订购人的前述信息。向我们提供该实际订购人的前述信息之前，您需确保您已经取得其授权同意。
        </p>
        <p>
          （2）为展示您账户的订单信息，我们会收集您在使用我们的服务过程中产生的订单信息用于向您展示及便于您对订单进行管理；
        </p>
        <p>
          （3）当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。
        </p>
        <p>
          （4）为确认交易状态及为您提供售后与争议解决服务，我们会通过您基于交易所选择的交易对象、支付机构、物流公司等收集与交易进度相关的您的交易、支付、物流信息，或将您的交易信息共享给上述服务提供者。
        </p>
        <p>
          3、<strong><strong>向您推送消息</strong></strong>
        </p>
        <p>
          向您推送消息。我们可能在必需时（例如当我们由于系统维护而暂停某一单项服务、变更、终止提供某一单项服务时）向您发出与服务有关的消息。如您不希望继续接收我们推送的消息，您可要求我们停止推送，您可在移动应用客户端个人设置中进行消息推送设置，不再接收我们推送的消息等；但我们依法律规定或单项服务的服务协议约定发送消息的情形除外。
        </p>
        <p>
          我们的商品和服务，包括但不限于：即时通讯服务、网上媒体服务、互动娱乐服务、社交网络服务、支付服务、互联网搜索服务、位置和地图服务、应用软件和服务、数据管理软件和服务、网上广告服务、及其他社交媒体、娱乐、网络游戏、电子商务、资讯及通讯软件和服务（&ldquo;互联网服务&rdquo;）；及第三方商品和服务，包括但不限于：互联网服务、食物和餐饮、体育、音乐、电影、电视、现场表演和其他艺术和娱乐、书册、杂志和其他刊物、服装和配饰、珠宝、化妆品、个人健康和卫生、电子、收藏品、家用器皿、电器、家居装饰和摆设、宠物、汽车、酒店、交通和旅游、银行、保险及金融服务、积分和奖励计划，以及我们认为可能与您相关的其他商品和服务。
        </p>
        <p>
          4、<strong><strong>为您提供安全保障</strong></strong>
        </p>
        <p>
          为确保您身份真实性、向您提供更好的安全保障，您可以向我们提供身份证明、面部特征等生物识别信息等个人敏感信息以完成实名认证。
        </p>
        <p>
          除身份验证外，我们可能将您的信息用于客户服务、安全防范、诈骗监测、存档和备份等用途，确保我们向您提供的服务的安全性；我们可能使用或整合我们所收集的您的信息，以及我们的合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
        </p>
        <p>
          5、<strong><strong>改进我们的服务</strong></strong>
        </p>
        <p>
          我们可能将通过某一项我们的服务所收集的信息，用于我们的其他服务。例如，在您使用某一项我们的服务时所收集的您的信息，可能在另一项我们的服务中用于向您提供特定内容或向您展示与您相关的、而非普遍推送的信息；我们可能让您参与有关我们的服务的调查，帮助我们改善现有服务或设计新服务；同时，我们可能将您的信息用于软件更新。
        </p>
        <p>
          您了解并同意，在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别您的身份，在此情况下我们有权使用已经去标识化的信息，对用户数据库进行分析并予以商业化的利用。
        </p>
        <p>
          如果我们将您的信息用于本《隐私政策》中未载明的其他用途，会事先征求您同意。
        </p>
        <p>6、征得授权同意的例外</p>
        <p>
          根据相关法律法规规定，以下情形中收集您的信息无需征得您的授权同意：
        </p>
        <p>（1）与国家安全、国防安全有关的；</p>
        <p>（2）与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>（3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
        <p>
          （4）出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
        </p>
        <p>（5）所收集的信息是您自行向社会公众公开的；</p>
        <p>
          （6）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；
        </p>
        <p>（7）根据您的要求签订合同所必需的；</p>
        <p>
          （8）用于维护我们的服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
        </p>
        <p>（9）为合法的新闻报道所必需的；</p>
        <p>
          （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；
        </p>
        <p>（11）法律法规规定的其他情形。</p>
        <p>三、我们可能分享、转让或披露的信息</p>
        <p>（一）分享</p>
        <p>我们可能会与第三方分享您的信息，详见第三方SDK目录中所示。</p>
        <p>
          2、维护和改善我们的服务。我们可能向合作伙伴及其他第三方分享您的信息，以帮助我们为您提供更有针对性、更完善的服务，例如：代表我们发出电子邮件或推送通知的通讯服务提供商等；
        </p>
        <p>
          3、实现本《隐私政策》第二条&ldquo;我们如何收集和使用信息&rdquo;部分所述目的；
        </p>
        <p>
          4、履行我们在本《隐私政策》或我们与您达成的其他协议中的义务和行使我们的权利；
        </p>
        <p>
          5、向委托我们进行推广的合作伙伴等第三方共享，但我们仅会向这些委托方提供推广的覆盖面和有效性的信息，而不会提供可以识别您身份的信息，例如姓名电话号码或电子邮箱；或者我们将这些信息进行汇总，以便它不会识别您个人。比如我们可以告知该委托方有多少人看了他们的推广信息或在看到这些信息后购买了委托方的商品，或者向他们提供不能识别个人身份的统计信息，帮助他们了解其受众或顾客。
        </p>
        <p>
          6、在法律法规允许的范围内，为了遵守法律、维护我们及我们的关联方或合作伙伴、您或其他我们的用户或社会公众利益、财产或安全免遭损害，比如为防止欺诈等违法活动和减少信用风险，我们可能与其他公司和组织交换信息。不过,这并不包括违反本《隐私政策》中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的信息。
        </p>
        <p>7、应您合法需求，协助处理您与他人的纠纷或争议；</p>
        <p>8、应您的监护人合法要求而提供您的信息；</p>
        <p>
          9、根据与您签署的单项服务协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；
        </p>
        <p>10、基于学术研究而提供；</p>
        <p>11、基于符合法律法规的社会公共利益而提供。</p>
        <p>
          我们仅会出于合法、正当、必要、特定、明确的目的共享您的信息。对我们与之共享信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本《隐私政策》以及其他任何相关的保密和安全措施来处理信息。
        </p>
        <p>（二）转让</p>
        <p>
          1、随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而您的信息有可能作为此类交易的一部分而被转移。我们会要求新的持有您信息的公司、组织继续受本《隐私政策》的约束，否则,我们将要求该公司、组织重新向您征求授权同意。
        </p>
        <p>2、在获得您的明确同意后，我们会向其他方转让您的信息。</p>
        <p>（三）披露</p>
        <p>
          我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会披露您的信息：
        </p>
        <p>1、根据您的需求，在您明确同意的披露方式下披露您所指定的信息；</p>
        <p>
          2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您信息的情况下，我们可能会依据所要求的信息类型和披露方式披露您的信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。
        </p>
        <p>四、我们如何保留、储存和保护信息</p>
        <p>
          我们仅在本《隐私政策》所述目的所必需期间和法律法规要求的时限内保留您的信息。
        </p>
        <p>我们在中华人民共和国境内运营中收集和产生的信息，存储在中国境内。</p>
        <p>我们将采取以下手段保护您的信息：</p>
        <p>（一）数据安全技术措施</p>
        <p>
          我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失。网络服务采取了多种加密技术，例如在某些服务中，我们将利用加密技术（例如SSL）来保护您的信息，采取加密技术对您的信息进行加密保存，并通过隔离技术进行隔离。
          在信息使用时，例如信息展示、信息关联计算，我们会采用多种数据脱敏技术增强信息在使用中安全性。采用严格的数据访问权限控制和多重身份认证技术保护信息，避免数据被违规使用。
        </p>
        <p>（二）我们为保护信息采取的其他安全措施</p>
        <p>
          我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范信息的存储和使用。
        </p>
        <p>
          我们通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。
        </p>
        <p>
          加强安全意识。我们还会举办安全和隐私保护培训课程，加强员工对于保护信息重要性的认识。
        </p>
        <p>
          （三）我们仅允许有必要知晓这些信息的我们的员工、合作伙伴访问您的信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您的信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与我们的的合作关系。
        </p>
        <p>（四）我们会采取一切合理可行的措施，确保未收集无关的信息。</p>
        <p>
          （五）互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件或其他服务软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的信息安全。
        </p>
        <p>
          （六）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
        </p>
        <p>（七）安全事件处置</p>
        <p>
          在通过我们的服务与第三方进行沟通或购买商品及服务时，您不可避免的要向交易对方或潜在的交易对方披露自己的信息，如联络方式或者邮政地址等。请您妥善保护自己的信息，仅在必要的情形下向他人提供。
        </p>
        <p>
          为应对信息泄露、损毁和丢失等可能出现的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们也为安全事件建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。
        </p>
        <p>
          在不幸发生信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报信息安全事件的处置情况。
        </p>
        <p>
          请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。
        </p>
        <p>五、如何管理您的信息</p>
        <p>（一）访问、更新和删除</p>
        <p>
          我们鼓励您更新和修改您的信息以使其更准确有效。您能通过我们的服务访问您的信息，并根据对应信息的管理方式自行完成或要求我们进行修改、补充和删除。我们将采取适当的技术手段，尽可能保证您可以访问、更新和更正自己的信息或使用我们的服务时提供的其他信息。
        </p>
        <p>
          在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障信息安全。对于通过COOKIES和WEB
          BEACON收集的您的信息，我们还在本《隐私政策》第二条&ldquo;COOKIES、日志档案和WEB
          BEACON&rdquo;部分说明了向您提供的选择机制。如您想查询、修改或删除您的部分信息，请登录我们的帐号中心或按照单项服务的具体指引进行操作。
        </p>
        <p>（二）公开与分享</p>
        <p>
          我们的多项服务可让您不仅与您的社交网络、也与使用该服务的所有用户公开分享您的相关信息，例如，您在我们的服务中所上传或发布的信息、您对其他人上传或发布的信息作出的回应，通过电子邮件或在我们的服务中不特定用户可见的公开区域内上传或公布您的个人信息，以及包括与这些信息有关的位置数据和日志信息。只要您不删除您所公开或共享的信息，有关信息可能一直留存在公众领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公众领域保存。如您将信息通过上述渠道公开或共享，由此造成您的信息泄露，我们不承担责任。因此，我们提醒并请您慎重考虑是否通过上述渠道公开或共享您的信息。
        </p>
        <p>（三）注销</p>
        <p>
          在符合我们的单项服务的服务协议约定条件及国家相关法律法规规定的情况下，您的该项我们的服务帐号可能被注销（注销设置路径：&ldquo;我的&rdquo;&mdash;&mdash;&ldquo;个人设置&rdquo;&mdash;&mdash;&ldquo;注销&rdquo;）。当帐号注销后，与该帐号相关的、该单项服务项下的全部服务资料和数据将依照单项服务的服务协议约定删除或处理。
        </p>
        <p>（四）改变您授权同意的范围</p>
        <p>
          您总是可以选择是否披露信息。有些信息是使用我们的服务所必需的，但大多数其他信息的提供是由您决定的。您可以通过删除信息、关闭设备功能等方式改变您授权我们继续收集信息的范围或撤回您的授权。
        </p>
        <p>
          当您撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的信息处理。
        </p>
        <p>（五）有关敏感信息的提示</p>
        <p>
          某些信息因其特殊性可能被认为是敏感信息，例如您的种族、宗教、个人健康和医疗信息等，以及身份证明文件、个人生物识别信息、财产信息、行踪轨迹、未成年人的信息等。
        </p>
        <p>
          请注意，您在我们的服务中所提供、上传或发布的内容和信息（例如有关您社交活动的照片或信息），可能会泄露您的敏感信息。您需要谨慎地考虑，是否使用我们的服务披露您的敏感信息。
        </p>
        <p>您同意您的敏感信息按本《隐私政策》所述的目的和方式来处理。</p>
        <p>六、其他第三方服务</p>
        <p>
          侨行天下可能接入或链接至第三方提供的社交媒体或其他服务（包括网站或其他服务形式）。包括：
        </p>
        <p>
          1、您可利用&ldquo;分享&rdquo;键将某些侨行天下服务内容分享到第三方服务，或您将第三方服务内容分享到侨行天下服务。这些功能可能会收集您的信息（包括您的日志信息），并可能在您的设备内装置COOKIES，从而正常运行上述功能；
        </p>
        <p>
          2、我们通过我们服务的其他方式向您提供链接，使您可以链接至第三方的服务或网站；
        </p>
        <p>
          3、其他接入第三方服务的情形。例如，为实现本政策中声明的目的，我们可能会接入第三方服务商提供的SDK或其他类似的应用程序（如以嵌入代码、插件等形式），以便向您提供更好的客户服务和用户体验。目前，我们接入的第三方服务商主要包括以下几种类型：
        </p>
        <p>（1）用于数据监测/统计、分享；</p>
        <p>（2）用于消息推送功能；</p>
        <p>
          （3）用于在您同意的情况下获取设备位置权限、搜集设备信息和日志信息等；
        </p>
        <p>
          （4）用于第三方授权服务，包括第三方帐号登陆、将有关内容分享至第三方产品；
        </p>
        <p>
          （5）用于帐号安全、产品加固相关服务，包括网络监测、域名解析、防劫持、反垃圾反作弊、加解密服务。
        </p>
        <p>
          我们接入的部分第三方SDK或类似应用程序可能会收集您的个人信息，如您在我们的服务中使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息。我们会评估这类第三方服务收集个人信息的合法性、正当性、必要性，要求该等第三方对您的个人信息采取保护措施，并严格遵守相关法律法规与监管要求。您可以查看《第三方SDK目录》，了解我们主要接入的第三方SDK基本情况，各单项服务接入第三方SDK的情况可能有不同，如需了解具体单项服务接入第三方SDK的详细情况，请您前往对应的服务页面并查阅我们各单项服务的具体条款和相关页面。您也可以选择通过本政策&ldquo;如何联系我们&rdquo;章节所列的反馈渠道联系我们，我们会尽快为您作出解答。
        </p>
        <p>第三方SDK目录</p>
        <p>
          <strong><strong>1.分享至微信、微信朋友圈SDK</strong></strong>
        </p>
        <p>
          使用目的：您可以选择分享平台上的公开信息至App外部，当您点击分享按钮进行操作时才会处理，如不收集使用此类信息，将无法使用分享至App外部功能，但不影响您使用App的基本业务功能。如需进一步了解微信分享功能的隐私政策，你可以进一步查阅《微信隐私保护指引》，链接：https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&amp;t=weixin_agreement&amp;s=privacy。
        </p>
        <p>
          <strong><strong>&nbsp;2.分享至QQ的SDK</strong></strong>
        </p>
        <p>
          应用场景：您可以选择分享平台上的公开信息至App外部，当您点击分享按钮进行操作时才会处理，如不收集使用此类信息，将无法使用分享至App外部功能，但不影响您使用App的基本业务功能。如需进一步了解分享至QQ功能的隐私政策，你可以进一步查阅《腾讯QQ隐私保护指引》，链接：https://rule.tencent.com/rule/preview/3fd52bde-6555-453b-9ab8-c5f1f3d22c62。
        </p>
        <p>
          3.<strong><strong>微信支付SDK:</strong></strong>
        </p>
        <p>
          应用目的或场景：您可以选择微信支付唤起微信支付购买APP里的相应商品，当您选择微信支付进行操作才会处理。
        </p>
        <p>
          <strong><strong>收集及共享个人信息的类型/范围：</strong></strong
          ><strong><strong>账单信息、调起微信支付</strong></strong>
        </p>
        <p>SDK服务提供商：财付通支付科技有限公司</p>
        <p>
          隐私政策链接：https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&amp;t=weixin_agreement&amp;s=privacy。
        </p>
        <p>4.支付宝支付SDK</p>
        <p>支付宝支付SDK</p>
        <p>SDK服务提供商：支付宝（中国）网络技术有限公司</p>
        <p>
          <strong
            ><strong
              >收集的个人信息类型：Android
              ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP
              地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi
              列表。</strong
            ></strong
          >
        </p>
        <p>使用目的：</p>
        <ol>
          <li>保障用户账户和资金安全以及支付服务的安全稳定运行。</li>
          <li>履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务。</li>
          <li>实现网络链路的选择和优化，以提升用户体验。</li>
        </ol>
        <p>SDK 隐私说明链接: https://opendocs.alipay.com/common/02kiq3</p>
        <p>5.网易七鱼SDK</p>
        <p>使用目的：帮助用户随时联系客服解决问题</p>
        <p>使用场景：联系客服</p>
        <p>共享方式：SDK本机采集</p>
        <p>
          <strong
            ><strong
              >涉及的个人信息/权限类型：拨打电话权限、麦克风权限、摄像头和相册权限</strong
            ></strong
          ><strong
            ><strong>、存储和发送最终用户的图片和视频信息的权限</strong></strong
          ><strong
            ><strong
              >、应用自启动权限、设备品牌及型号、设备所运行系统版本、名称、编辑版本信息、网络状态、wifi信息，IP地址，运营商信息、浏览器类型及版本信息、云信通信服务运行日志信息、</strong
            ></strong
          ><strong><strong>应用包名、</strong></strong
          ><strong><strong>距离传感器信息、剪切板功能</strong></strong
          ><strong><strong>。</strong></strong>
        </p>
        <p>
          具体请见《网易七鱼SDK隐私政策》中第一条
          我们如何收集和使用您及最终用户的个人信息，链接：https://qiyukf.com/termsService。
        </p>
        <p>6.华为推送SDK</p>
        <p>使用目的：推送消息</p>
        <p>数据类型：设备标识信息</p>
        <p>华为推送会收集使用的个人信息：</p>
        <p>客户的ID、应用ID、应用包名、服务器公网IP地址。</p>
        <p>
          当我们在AppGallery
          Connect网站上创建消息推送任务后，华为推送将收集各功能的使用频次、任务名称、消息内容和推送范围(应用Token、或者主题名称、或者受众群组名称)信息，并按照我们选择的数据处理位置进行数据处理;
        </p>
        <p>另外，华为Push会收集客户的终端用户的以下信息：</p>
        <p>
          <strong
            ><strong
              >AAID(应用匿名标识)、应用Token、Topic订阅关系。</strong
            ></strong
          >
        </p>
        <p>
          <strong
            ><strong
              >消息下发记录、Token申请记录、显示/点击/关闭打点上报记录。</strong
            ></strong
          >
        </p>
        <p>
          <strong
            ><strong
              >缓存消息内容，根据客户端所在的大区位置的分布)进行数据处理。</strong
            ></strong
          >
        </p>
        <p>
          我们启用了基于华为帐号的消息校验功能，华为推送将在该场景下收集手机用户的标识符HMS
          Core openId，HMS Core openId将进行不可逆加密仅保存在设备端侧。
        </p>
        <p>
          <strong
            ><strong
              >华为发送的消息内容将被保存到最终用户设备端侧。</strong
            ></strong
          >
        </p>
        <p>
          以上第三方社交媒体或其他服务由相关的第三方负责运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何信息），须受第三方自己的服务条款及信息保护声明（而非本政策）约束，您需要仔细阅读其条款。本政策仅适用于我们所收集的个人信息，并不适用于任何第三方提供的服务或第三方的信息使用规则。如您发现这些第三方社交媒体或其他服务存在风险时，建议您终止相关操作以保护您的合法权益并及时与我们取得联系。
        </p>
        <p><strong></strong><strong> 7.友盟统计分析SDK</strong></p>
        <p>SDK名称：友盟统计分析SDK</p>
        <p>使用目的：进行APP运营统计与分析</p>
        <p>运营方：友盟同欣（北京）科技有限公司</p>
        <p>
          收集个人信息类型：<strong
            ><strong
              >设备信息（IMEI/MAC/Android
              ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息</strong
            ></strong
          >
        </p>
        <p>
          隐私权政策链接：<a href="https://www.umeng.com/page/policy"
            ><u>https://www.umeng.com/page/policy</u></a
          >
        </p>
        <ol>
          <li>
            极光推送sdk<br /><strong><strong>SDK名称</strong></strong
            >：极光推送 SDK<br /><strong><strong>第三方主体</strong></strong
            >：深圳市和讯华谷信息技术有限公司<br /><strong
              ><strong>SDK 用途</strong></strong
            >：为 APP 用户提供信息推送服务<br /><strong
              ><strong>处理个人信息类型</strong></strong
            ><strong
              ><strong
                >：设备标识符（包括IMEI、IDFA、AndroidID、GAID、MAC、OAID、IMSI、MEID、UAID）、设备硬件信息（包括设备型号、设备屏幕分辨率、设备硬件制造商、设备产品名称）、操作系统信息（包括操作系统版本、系统名称、系统语言）、网络信息（包括网络类型、运营商名称、基站信息、IP地址、WiFi信息、SSID、BSSID）、推送信息日志、</strong
              ></strong
            ><strong><strong>精确位置信息</strong></strong
            ><strong
              ><strong
                >、软件列表信息（包括软件列表及软件运行列表信息）。</strong
              ></strong
            ><br /><strong><strong>数据处理方式</strong></strong
            >：通过去标识化、加密传输及其他安全方式<br /><strong
              ><strong>极光隐私权政策链接</strong></strong
            >：《<a href="https://www.jiguang.cn/license/privacy"
              >AURORA 极光隐私政策</a
            >》<br /><strong><strong>官网链接</strong></strong
            >：<a href="https://www.jiguang.cn/">https://www.jiguang.cn/</a>
          </li>
        </ol>
        <p>七、如何联系我们</p>
        <p>
          如您有关于网络信息安全的投诉和举报，或您对本《隐私政策》、您的信息的相关事宜有任何问题、意见或建议，以及有关本声明或我们的的隐私措施的问题请与我们的的协调人联系。联系方式400-022-1010。
        </p>
        <h3>本隐私政策修订于2023年5月8日</h3>
      </template>
      <template v-else-if="type == 5">
        <h1>
          侨行天下用户使用协议
        </h1>
        <p>
          重要提示：<br />本服务协议为浙江黄金宝投资股份有限公司（以下称“本公司”）与您签订。在您通过本公司系统（本公司系统：官网www.goldplusgold.com，手机端：侨行天下APP）注册成为本公司的用户前请务必仔细阅读以下条款。若您完成本公司系统指定的注册流程，则表示您同意接受本公司的服务并受以下条款的约束。若您不接受以下条款，请您立即停止注册或使用本公司的服务。
        </p>
        <p>
          第一章 特别提醒<br />第一条
          本公司只接受持有中国（不含港澳台地区）有效身份证明的18周岁以上具有完全民事行为能力的自然人成为注册用户。如您不符合资格，请勿注册，否则本公司有权随时中止或终止您的用户资格，因此所导致的任何后果甶您个人承担。<br />第二条
          本协议内容包括以下条款及本公司系统上已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的一部分，与协议正文具有同等法律效力。<br />第三条
          本公司有权根据需要不时地修改本协议或根据本协议制定、修改各类具体规则并在本公司相关系统板块上发布，无需另行单独通知您。<br />(1)如您不同意变更后的协议及相关规则内容，应立即停止通过本公司系统进行所有交易。<br />(2)若您在本协议及具体规则内容公告变更后继续使用本公司服务的，表示您已充分阅读、理解并接受修改后的协议和具体规则内容；同时就您在协议和具体规则修订前通过本公司系统进行的交易及其效力，视为您已同意并已按照本协议及有关规则进行了相应的授权和追认。<br />第四条在您注册成为用户时，您已经阅读、理解并接受本协议的全部条款及各类规则，如有违反而导致任何法律后果的发生，您将以自己的名义独立承担相应的法律责任。<br />第五条您同意以网络页面点击确认的方式签署本协议，并不以此为由拒绝履行本协议及协议下的规则上约定的义务。在您点击确认本协议后，本协议即在您和本公司之间产生法律效力。
        </p>
        <p>
          第二章 风险告知<br />您作为注册用户使用本公司系统时，已知悉通过本公司系统进行相关交易可能存在诸多风险，包括但不限于以下风险：<br />第一条
          政策风险<br />甶于国家法律、法规、政策的变化，紧急措施的出台，相关监管部门监管措施的实施，交易所交易规则的修改等原因，均可能会对您的交易产生影响，您必须承担由此导致的损失。<br />第二条
          黄金价格波动风险<br />黄金价格受多种因素的影响（如国际经济形势、美元汇率、相关市场走势、政治局势、原油价格等等），这些因素对金价的影响机制非常复杂，如果不能有效控制风险，则可能遭受损失。<br />第三条
          技术风险<br />本公司所提供的服务系通过电子通讯技术和互联网技术来实现。可能会存在品质和稳定性方面的风险，通讯或网络故障导致的某些服务中断或延时，另外您的电脑系统或手机APP端也可能会甶于网络信息或者病毒或网络黑客攻击等不确定因素，有可能会给您的交易带来一定影响。<br />第四条
          不可抗力风险<br />本公司提供的服务在遇到地震、水灾、火灾、暴动、罢工、战争、政府管制、国内外的禁止或限制以及停电、技术故障、电子故障等其他无法预测和防范的不可抗力事件时，都有可能会对您的交易产生影响或造成其损失。
        </p>
        <p>
          第三章 用户信息及账户安全<br />第一条 用户注册及验证<br />(1)您在本公司的注册采用实名认证，您应保证提供的姓名、联系电话、联系地址、电子邮件地址等内容的真实性、安全性和有效完整性，以便本公司为您提供服务时能及时与您取得联系。<br />(2)您同意本公司自行或通过合作的第三方机构对您提交或本公司搜集的用户信息（包括但不限于您的个人身份证信息等）进行核实，并对获得的核实结果根据本协议及有关文件进行查看、使用和留存等操作。若甶于您信息不真实、完整的，我公司有权暂停或终止您的注册申请。<br />(3)若您的信息变更的，应及时联系侨行天下客服（客服电话:400-022-1010)及时办理变更手续。<br />若甶于您未能及时更新个人信息导致本公司为您提供的服务过程中遭受损失或增加费用等的，甶您本人承担相应的不利后果;若由此给我公司及其他关联公司造成损失的，您应承担相应的赔偿责任。<br />第二条
          账户安全<br />(1)您的账号仅限本人使用，不可转让及赠送。您确认，无论是您还是您的代理人，用您的用户名和密码登录本公司系统后在本公司的一切行为均代表您并由您承担相应的法律后果。<br />(2)您有义务保管好账号、密码等个人信息：<br />若您发现有第三人冒用或盗用您的用户账户及密码，或其他任何未经合法授权的情形，应立即通知本公司，要求本公司暂停相关服务，否则由此产生的一切责任由您本人承担。<br />(3)您须仔细甄别确认为本公司的系统后再登陆，因您不慎误登录钓鱼网站等非正规网站而导致的经济损失，由您自行承担。<br />第三条
          隐私保护<br />（1）您同意并授权本公司将您的包括但不限于真实姓名、联系方式等必要的个人信息和交易信息披露给与您交易的另一方或本公司的合作机构（仅限于本公司为完成拟向您提供的服务而合作的机构）。<br />（2）本公司有义务根据有关法律要求向司法机关和政府部门提供您的个人资料。<br />（3）您同意接收本公司以电子邮件或短信形式向其手机（手机号码、邮件地址）发布促销等信息（接收短信不收取任何费用。<br />（4）本公司对于您提供的、自行收集到的、经认证的个人信息将按照本协议及有关规则予以保护、使用或者披露。本公司将保护您的个人资料，但鉴于技术限制，本公司不能确保您的全部私人通讯及其他个人资料不被相关方以其他方式获取。
        </p>
        <p>
          第四章 提供的服务<br />第一条
          本公司提供的服务包括但不限于：黄金报价、黄金实物的购买、黄金实物的提取、饰品换购、黄金的回收等，具体详情以本公司当时提供的服务内容为准。<br />第二条
          基于运行和交易安全的需要，本公司可暂时停止提供、限制或改变本公司服务的部分功能，或提供新的功能。在任何功能变化时，只要您仍然使用本公司提供的服务，表示您同意本协议或变更后的协议。<br />第三条
          您在本公司系统上按相应的服务流程所确认的交易状态将成为本公司为您进行相关交易或操作（包括但不限于冻结资金、代为支付或收取款项、订立合同等）的明确指令。您同意本公司有权按相关指令依据本协议和/或有关文件和规则对相关事项进行处理。<br />第四条
          您未能及时对交易状态进行修改或确认或未能提交相关申请所引起的任何纠纷或损失甶您本人负责，本公司不承担任何责任。
        </p>
        <p>
          第五章 实物黄金交易及费用<br />第一条
          在本公司系统上，您可以提交“实物黄金购买”订单、提交“实物黄金回收”订单、实物黄金提取、申请换购、以旧换新等业务，其他业务的开通以本公司公告为准，具体的操作规则请见相关页面的规则和说明。<br />第二条
          在为您提供上述服务时，可能会收取相应的服务费用，具体内容请参照有关文件及本公司系统上相关页面的规则和说明。同时，本公司有权不时调整前述服务或管理费用的类型或金额等具体事项并根据本协议和相关规则进行公告、修改。
        </p>
        <p>
          第六章 实物黄金购买、提取与换购<br />第一条
          本公司所销售的实物黄金产品，可接受您的直接购买，也可使用在本公司购买的实物黄金进行换购；<br />换购的或线上提货的产品：本公司有权根据实物黄金产品库存及订单情况，规定在特定时间内可供出售或可交割、换购的实物黄金产品限额。<br />第二条
          本公司所提供的实物黄金产品的纯度、规格、款式等信息详见公司系统上相关产品介绍页面。<br />第三条
          您在本公司系统上指定的提货点提货进行或选择快递提金，具体按照页面上可选定的操作。
        </p>
        <p>
          第七章 货品运输及退换货<br />第一条
          在您购买、交割或换购实物黄金产品交易完成后，因原料环节、生产环节、物流环节或其他非本公司主观原因导致您无法按本公司系统上声明的规定时间收到实物黄金产品的，本公司不承担相关责任。<br />第二条
          本公司所有实物黄金产品通过系统规定的方式发送至您选定的提货门店，包括但不限于快递、普通邮寄等。本公司所有实物黄金产品的发送均向保险公司投保，以保障您的财产安全;您选定的门店在收到货品后会第一时间通知您取货，请您及时去提取货品，并与门店进行核验。如您对货品产生疑问的，请当场拒收。<br />第三条
          本公司所有实物黄金产品一经签收不接受无偿退货。(由于实物黄金产品的特殊性，请您在货签收时确认，本产品一经签署不适用无理由退货）。
        </p>
        <p>
          第八章 资金管理<br />第一条
          就您在本公司系统上进行的实物黄金交易或实物黄金产品购买，本公司委托的第三方机构将为您提供“资金管理服务”，主要包括但不限于：资金的充值、提现、代收、代付、查询等。您可以通过本公司系统的有关页面的具体规则或说明详细了解。<br />第二条
          您已知悉，上述资金充值、提现、代收、代付以及查询等服务涉及本公司与第三方支付机构或金融机构的合作，并对下述事项予以认可：（a)受第三方支付机构或金融机构可能仅在工作日进行资金代扣及划转的现状等各种原因所限，本公司不对前述服务的资金到账时间做任何承诺，也不承担与此相关的责任，包括但不限于由此产生的利息、货币贬值等损失；（b)—经您使用前述服务，即表示您不可撤销地授权本公司进行相关操作，且该等操作是不可逆转的，您不能以任何理由拒绝付款或要求取消交易。就前述服务，您应按照有关文件及第三方支付机构或金融机构的规定支付第三方的费用，您与第三方之间就费用支付事项产生的争议或纠纷，与本公司无关。<br />第三条
          您保证并承诺您用于参与本公司相关交易的资金来源的合法和实物黄金来源的合法且不会受到任何其他方的权利追索。您同意，本公司有权按照包括但不限于公安机关、检察机关、<br />法院等司法机关、行政机关、军事机关的要求协助对您的账户及资金等进行查询、冻结或扣划等操作。<br />第四条
          如果本公司发现了因系统故障或其他原因导致的处理错误，无论有利于本公司还是有利于您，本公司有权在根据本协议规定通知您后纠正该错误。您理解并同意，本公司不承担因前述处理错误而导致的任何损失或责任（包括您可能因前述错误导致的收益等损失），但因本公司恶意或重大过失而导致的处理错误除外。
        </p>
        <p>
          第九章 免责条款<br />第一条
          您同意，本公司不能保证也没有义务保证第三方网站上的信息的真实性、准确性和有效性。您应按照第三方网站的服务协议使用第三方网站，而不是按照本协议。第三方网站的内容、产品、广告和其他任何信息均甶您自行判断并承担风险，而与本公司无关。<br />第二条
          鉴于技术及设备的局限性，因为本公司或者涉及的第三方网站的设备、系统存在缺陷、被黑客攻击、出现网络故障、<br />电力中断、计算机病毒或其他不可抗力因素造成的损失，本公司不承担相应的赔偿责任，您可以与本公司协商终止本协议并停止使用本公司系统。但是，中国现行法律、法规另有规定的除外。<br />第三条
          在任何情况下，对于您使用本公司服务过程中涉及由第三方提供相关服务的责任由该第三方承担，本公司不承担该等责任。因您自身的原因导致本公司服务无法提供或提供时发生任何错误而产生的任何损失或责任，甶您自行负责，本公司不承担责任。
        </p>
        <p>
          第十章 使用限制<br />第一条
          您承诺合法使用本公司提供的服务及内容。您不得利用本公司系统从事侵害他人合法权益的行为、或违法违规之行为、或任何未经授权的行为等。<br />第二条
          由于您违反本协议或法律、法规或侵害第三方的权利，而引起第三方对本公司提出的任何形式的索赔、权利主张或要求、诉讼，本公司有权向您追偿相关的直接损失或间接损失，包括但不限于本公司因此支付的法律服务等中介费用、名誉损失、及向第三方支付的补偿金、损害赔偿金等。
        </p>
        <p>
          第十一章 协议终止及账户的暂停、注销或终止<br />第一条
          除非本公司终止本协议或者您申请终止本协议且经本公司同意，否则本协议始终有效。<br />第二条
          您决定不再使用用户账户时，应首先清偿所有应付款项（包括但不限于服务费、管理费等），再将用户账户中的可用款项（如有）全部提现或者向公司系统发出其它合法的支付指令，并向本公司申请注销该用户账户，经本公司审核同意后可正式注销用户账户。<br />注册会员死亡或被宣告死亡的，其在本协议项下的各项权利义务由其继承人承担。若注册会员丧失全部或部分民事权利能力或民事行为能力，本公司有权根据有效法律文书（包括但不限于生效的法院判决等）或其法定监护人的指示处置与用户账户相关的款项。<br />第三条
          如发生如下情形的，您认可，本公司有权基于单方独立判断在认为可能发生危害交易安全等情形时，可先行暂停、中断或终止向您提供本协议项下的全部或部分服务，且无需对您或任何第三方承担任何责任。前述情形包括但不限于：<br />（1）本公司认为您提供的个人资料不具有真实性、有效性或完整性；<br />（2）您使用本公司服务的行为涉嫌违反国家法律法规及行政规定的；<br />（3）本公司发现异常交易或有疑义或有违法之虞时；<br />（4）本公司认为您的账户涉嫌洗钱、套现、传销、被冒用或其他本公司认为有风险之情形；或认为账户操作、黄金现货、资金进出等存在异常时；<br />（5）本公司收到有权机关的要求；<br />（6）您受到第三方的投诉，且对方已经提供了一定证据的；<br />（7）本公司认为您已经违反本协议之内容；<br />（8）本公司基于交易安全等原因，需先行暂停、中断或终止向您提供本协议项下的全部或部分会员服务，并将注册资料移除或删除的其他情形。<br />（9）在您违反了本协议及相关规则，或在相关法律法规、政府部门的要求下，本公司有权通过电子邮件通知或短信的等方式终止本协议、关闭您的账户或者限制您使用本公司系统。但本公司的终止行为不能免除您根据本协议或在本公司系统上生成的其他协议项下的还未履行完毕的义务。<br />第四条
          您同意，在必要时，本公司无需进行事先通知即有权终止提供用户账户服务，并可能立即暂停、关闭或删除您的用户账户及该用户账户中的所有相关资料及档案，并将您滞留在这些<br />账户的全部合法资金退回到您的银行账户。<br />第五条
          您同意，用户账户的暂停、中断或终止不代表您在本协议项下及本公司相关交易行为中责任和义务的终止，您仍应对您使用本公司系统服务期间的行为承担可能的违约或损害赔偿责任，同时本公司仍可保有您的相关信息。
        </p>
        <p>
          第十二章 协议生效及变更<br />第一条
          在不损害您利益的前提下，本公司保留修改或增补本协议内容的权利。本协议的修改文本将由本公司通过与业务内容相适应的方式进行公告或以其他本公司认为可行的方式通知。<br />第二条
          本协议书生效后，若有关法律法规或其他本公司和您应共同遵守的法律依据发生修订，本协议与之不相适应的内容及条款自行失效，但本协议其他内容和条款继续有效。
        </p>
        <p>
          第十三章 通知及送达条款<br />本协议项下的通知如以公示方式作出，一经在本公司系统上公示即视为已经送达。除此之外，其他向您个人发布的具有专属性的通知将由本公司向您在注册时提供的电子邮箱，或您在注册后绑定的手机发送，一经发送即视为已经送达。您同时同意并确认，若您设置了不接收有关通知或提醒，则您有可能无法收到该等通知信息，您不得以您未收到或未阅读该等通知信息主张相关通知未送达于您。
        </p>
        <p>
          第十四章 适用法律和争议解决<br />本协议之效力、解释、变更、执行与因本公司所提供服务而产生的争议均适用中国法律，并由将争议提交杭州市仲裁委员会，依据该会届时有效的仲裁规则进行仲裁。仲裁裁决是终局裁决，对双方均有强制执行力。仲裁期间，本协议不涉及争议的条款应继续履行。
        </p>
        <p>
          第十五章 其他<br />在法律法规允许的范围内，本公司对本协议享有修改权和最终解释权。本协议及本公司系统有关页面的相关名词可互相引用参照，如有不同理解，则以本协议条款为准。此外，若本协议的部分条款被认定为无效或者无法实施时，本协议中的其他条款仍效有效。
        </p>
        <p>
          第十六章 名词定义<br />实物黄金或实物黄金产品：是指本公司系统上所销售的实物黄金产品，包括但不限于金币、金条、黄金饰品等产品。<br />用户：是指向本公司系统进行交易的有民事主体资格的自然人（须在本公司系统上注册并通过实名认证并绑定银行卡）。
        </p>
      </template>
      <template v-else-if="type == 6">
        <p style=";text-indent: 0;padding: 0;text-align: center">
          <strong
            ><span
              style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
              >隐私政策</span
            ></strong
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >前言：</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >浙江黄金宝投资股份有限公司</span
          ><span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑"
              >及旗下软件或各关联公司（以下统称</span
            >“</span
          ><span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >黄金宝</span
          ><span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >”或”侨行天下”或“我们”）一向庄严承诺保护使用</span
          ><span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >黄金宝</span
          ><span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">的产品和服务（以下统称</span
            >“</span
          ><span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >黄金宝</span
          ><span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">服务</span
            >”或“侨行天下服务”或“我们的服务”）之用户（以下统称“用户”或“您”）的隐私。您在使用</span
          ><span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >黄金宝</span
          ><span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >服务时，我们可能会收集和使用您的相关信息。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >本《隐私政策》适用于我们提供的一切</span
          ><span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >黄金宝</span
          ><span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑"
              >服务。当您使用我们任何单项服务时，您同意接受本《隐私政策》以及我们在该单项服务中发出的特定隐私信息类政策条款（下列称</span
            >“特定条款”）的保护，在此情况下特定条款与本政策条款同时对您产生效力。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >请注意我们不时地会检查我们的政策，因此有关的措施会随之变化。我们恳请您定期光顾本页面，以确保对我们《隐私政策》最新版本始终保持了解。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >一、我们可能收集的信息</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（一）与个人身份无关的信息：</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >当您使用我们的服务时，我们可能收集和汇总诸如用户的来源途径、访问顺序等信息，例如记录使用我们的服务的每个用户的来源途径、浏览器软件等。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（二）有关个人身份的信息：</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑"
              >当您使用我们的服务时，我们可能收集和汇总或要求您提供有关个人身份的信息，例如个人身份证明（包括身份证、护照、驾驶证等）；生日、籍贯、性别、兴趣爱好、个人电话号码、面部特征；网络身份标识信息（包括系统账号、</span
            >IP地址、电子邮箱地址及与前述有关的密码、口令、口令保护答案等）；个人财产信息（交易记录、余额、优惠券、银行卡信息等）；通讯信息；个人上网记录和日志信息（包括网站浏览记录、软件使用记录、点击记录、操作日志等）；设备信息（包括设备型号、设备MAC地址、操作系统类型、设备设置）；软件列表唯一设备识别码（如IMEI/android
            ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息）；位置信息（包括行程信息、精准定位信息、住宿信息、经纬度等）。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >我们收集您的信息主要是为了您和其他用户能够更容易和更满意地使用我们的服务。我们的目标是向所有的互联网用户提供安全、刺激、有趣及有教益的上网经历。而这些信息有助于我们实现这一目标。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >请注意，如您在我们的服务中其他用户可见的公开区域内上传或发布的信息中、您对其他人上传或发布的信息作出的回应中公开您的个人信息，该等信息可能会被他人收集并加以使用。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >二、我们如何收集和使用信息</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（一）我们将通过以下途径收集和获得您的信息：</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >1、您提供的信息。 例如：</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >1）您在注册我们的服务的帐号或使用我们的服务时，向我们提供的信息；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >2）您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >2、其他方分享的您的信息。亦即其他方使用我们的服务时所提供有关您的共享信息。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >3、我们获取的您的信息。您在使用我们的服务时，我们收集、汇总、记录的信息，例如日志信息、位置信息、设备信息等。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（二）</span
            >COOKIES、日志档案和WEB BEACON</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑"
              >我们或我们的第三方合作伙伴可能通过</span
            >COOKIES和WEB
            BEACON获取和使用您的信息，并将该等信息储存为日志信息。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">通过使用</span
            >COOKIES，我们向用户提供简单易行并富个性化的网络体验。一个COOKIES是少量的数据，它们从一个网络服务器送至您的浏览器并存在计算机硬盘上。我们使用COOKIES是为了让其用户可以受益。COOKIES使得我们能更好、更快地为您服务，并且使您在我们的服务上的经历更富个性化。然而，您应该能够控制COOKIES是否以及怎样被你的浏览器接受。请查阅您的浏览器附带的文件以获得更多这方面的信息。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑"
              >我们和第三方合作伙伴可能通过</span
            >COOKIES和WEB BEACON收集和使用您的信息，并将该等信息储存。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">我们使用自己的</span
            >COOKIES和WEB BEACON，用于以下用途：</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >1）记住您的身份。例如：COOKIES和WEB
            BEACON有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供有关您的喜好或其他信息；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >2）分析您使用我们服务的情况。我们可利用COOKIES和WEB
            BEACON来了解您使用我们的服务进行什么活动、或哪些服务或服务最受欢迎；及</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >3）广告优化。COOKIES和WEB
            BEACON有助于我们根据您的信息，向您提供与您相关的广告而非进行普遍的广告投放。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">我们为上述目的使用</span
            >COOKIES和WEB BEACON的同时，可能将通过COOKIES和WEB
            BEACON收集的非个人身份信息汇总提供给广告商和其他伙伴，用于分析您和其他用户如何使用我们的服务并用于广告服务。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑"
              >我们的服务上可能会有广告商和其他合作方放置的</span
            >COOKIES和WEB BEACON。这些COOKIES和WEB
            BEACON可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务、向您发送您可能感兴趣的广告，或用于评估广告服务的效果。这些第三方COOKIES和WEB
            BEACON收集和使用该等信息不受本《隐私政策》约束，而是受到其自身的个人信息保护声明约束，我们不对第三方的COOKIES或WEB
            BEACON承担责任。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑"
              >您可以通过浏览器或用户选择机制拒绝或管理</span
            >COOKIES或WEB BEACON。但请您注意，如果您停用COOKIES或WEB
            BEACON，我们有可能无法为您提供最佳的服务体验，某些服务也可能无法正常使用。同时，您仍然将收到广告，只是这些广告与您的相关性会降低。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（三）我们会出于以下目的，收集和使用您的信息：</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >1、帮助您完成注册</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >为便于我们为您提供服务，您需要提供基本注册信息，例如手机号码、电子邮箱地址等，并创建您的用户名和密码。在部分单项服务中，如果您仅需使用浏览、搜索等基本服务，您不需要注册成为我们的用户及提供上述信息。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >2、向您提供商品或服务</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >我们所收集和使用的信息是为您提供我们的服务的必要条件，如缺少相关信息，我们将无法为您提供我们的服务的核心内容，例如：</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >1）在部分服务项目中，为便于向您交付商品或服务，您需提供收货人个人身份信息、姓名、收货地址、邮政编码、收货人、联系电话、支付状态等信息。如果您拒绝提供此类信息，我们将无法完成相关交付服务。如您通过我们的服务为其他人订购商品或服务，您需要提供该实际订购人的前述信息。向我们提供该实际订购人的前述信息之前，您需确保您已经取得其授权同意。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >2）为展示您账户的订单信息，我们会收集您在使用我们的服务过程中产生的订单信息用于向您展示及便于您对订单进行管理；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >3）当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >4）为确认交易状态及为您提供售后与争议解决服务，我们会通过您基于交易所选择的交易对象、支付机构、物流公司等收集与交易进度相关的您的交易、支付、物流信息，或将您的交易信息共享给上述服务提供者。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >3、向您推送消息</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >1）为您展示和推送商品或服务。我们可能使用您的信息，您的浏览及搜索记录、设备信息、位置信息、订单信息，提取您的浏览、搜索偏好、行为习惯、位置信息等特征，并基于特征标签通过电子邮件、短信或其他方式向您发送营销信息，提供或推广我们或第三方的如下商品和服务：</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑"
              >我们的商品和服务，包括但不限于：即时通讯服务、网上媒体服务、互动娱乐服务、社交网络服务、支付服务、互联网搜索服务、位置和地图服务、应用软件和服务、数据管理软件和服务、网上广告服务、及其他社交媒体、娱乐、网络游戏、电子商务、资讯及通讯软件和服务（</span
            >“互联网服务”）；及第三方商品和服务，包括但不限于：互联网服务、食物和餐饮、体育、音乐、电影、电视、现场表演和其他艺术和娱乐、书册、杂志和其他刊物、服装和配饰、珠宝、化妆品、个人健康和卫生、电子、收藏品、家用器皿、电器、家居装饰和摆设、宠物、汽车、酒店、交通和旅游、银行、保险及金融服务、积分和奖励计划，以及我们认为可能与您相关的其他商品和服务。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >2）向您发出通知。我们可能在必需时（例如当我们由于系统维护而暂停某一单项服务、变更、终止提供某一单项服务时）向您发出与服务有关的通知。如您不希望继续接收我们推送的消息，您可要求我们停止推送，例如：根据短信退订指引要求我们停止发送推广短信，或在移动端设备中进行设置，不再接收我们推送的消息等；但我们依法律规定或单项服务的服务协议约定发送消息的情形除外。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >4、为您提供安全保障</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >为确保您身份真实性、向您提供更好的安全保障，您可以向我们提供身份证明、面部特征等生物识别信息等个人敏感信息以完成实名认证。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >除身份验证外，我们可能将您的信息用于客户服务、安全防范、诈骗监测、存档和备份等用途，确保我们向您提供的服务的安全性；我们可能使用或整合我们所收集的您的信息，以及我们的合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >5、改进我们的服务</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >我们可能将通过某一项我们的服务所收集的信息，用于我们的其他服务。例如，在您使用某一项我们的服务时所收集的您的信息，可能在另一项我们的服务中用于向您提供特定内容或向您展示与您相关的、而非普遍推送的信息；我们可能让您参与有关我们的服务的调查，帮助我们改善现有服务或设计新服务；同时，我们可能将您的信息用于软件更新。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >您了解并同意，在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别您的身份，在此情况下我们有权使用已经去标识化的信息，对用户数据库进行分析并予以商业化的利用。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >如果我们将您的信息用于本《隐私政策》中未载明的其他用途，会事先征求您同意。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >6、征得授权同意的例外</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >根据相关法律法规规定，以下情形中收集您的信息无需征得您的授权同意：</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >1）与国家安全、国防安全有关的；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >2）与公共安全、公共卫生、重大公共利益有关的；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >3）与犯罪侦查、起诉、审判和判决执行等有关的；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >4）出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >5）所收集的信息是您自行向社会公众公开的；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >6）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >7）根据您的要求签订合同所必需的；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >8）用于维护我们的服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >9）为合法的新闻报道所必需的；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >11）法律法规规定的其他情形。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >三、我们可能分享、转让或披露的信息</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（一）分享</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >除以下情形外，未经您同意，我们不会与之外的任何第三方分享您的信息：</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >1、向您提供我们的服务。我们可能向合作伙伴及其他第三方分享您的信息，以实现您需要的核心功能或提供您需要的服务，例如：向物流服务商提供对应的订单信息；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >2、维护和改善我们的服务。我们可能向合作伙伴及其他第三方分享您的信息，以帮助我们为您提供更有针对性、更完善的服务，例如：代表我们发出电子邮件或推送通知的通讯服务提供商等；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >3、实现本《隐私政策》第二条“我们如何收集和使用信息”部分所述目的；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >4、履行我们在本《隐私政策》或我们与您达成的其他协议中的义务和行使我们的权利；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >5、向委托我们进行推广的合作伙伴等第三方共享，但我们仅会向这些委托方提供推广的覆盖面和有效性的信息，而不会提供可以识别您身份的信息，例如姓名电话号码或电子邮箱；或者我们将这些信息进行汇总，以便它不会识别您个人。比如我们可以告知该委托方有多少人看了他们的推广信息或在看到这些信息后购买了委托方的商品，或者向他们提供不能识别个人身份的统计信息，帮助他们了解其受众或顾客。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >6、在法律法规允许的范围内，为了遵守法律、维护我们及我们的关联方或合作伙伴、您或其他我们的用户或社会公众利益、财产或安全免遭损害，比如为防止欺诈等违法活动和减少信用风险，我们可能与其他公司和组织交换信息。不过,这并不包括违反本《隐私政策》中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的信息。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >7、应您合法需求，协助处理您与他人的纠纷或争议；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >8、应您的监护人合法要求而提供您的信息；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >9、根据与您签署的单项服务协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >10、基于学术研究而提供；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >11、基于符合法律法规的社会公共利益而提供。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >我们仅会出于合法、正当、必要、特定、明确的目的共享您的信息。对我们与之共享信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本《隐私政策》以及其他任何相关的保密和安全措施来处理信息。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（二）转让</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >1、随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而您的信息有可能作为此类交易的一部分而被转移。我们会要求新的持有您信息的公司、组织继续受本《隐私政策》的约束，否则,我们将要求该公司、组织重新向您征求授权同意。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >2、在获得您的明确同意后，我们会向其他方转让您的信息。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（三）披露</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会披露您的信息：</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >1、根据您的需求，在您明确同意的披露方式下披露您所指定的信息；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            >2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您信息的情况下，我们可能会依据所要求的信息类型和披露方式披露您的信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >四、我们如何保留、储存和保护信息</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >我们仅在本《隐私政策》所述目的所必需期间和法律法规要求的时限内保留您的信息。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >我们在中华人民共和国境内运营中收集和产生的信息，存储在中国境内。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >我们将采取以下手段保护您的信息：</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（一）数据安全技术措施</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑"
              >我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的信息遭到未经授权的访问使用、修改</span
            >,避免数据的损坏或丢失。网络服务采取了多种加密技术，例如在某些服务中，我们将利用加密技术（例如SSL）来保护您的信息，采取加密技术对您的信息进行加密保存，并通过隔离技术进行隔离。
            在信息使用时，例如信息展示、信息关联计算，我们会采用多种数据脱敏技术增强信息在使用中安全性。采用严格的数据访问权限控制和多重身份认证技术保护信息，避免数据被违规使用。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（二）我们为保护信息采取的其他安全措施</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范信息的存储和使用。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >我们通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >加强安全意识。我们还会举办安全和隐私保护培训课程，加强员工对于保护信息重要性的认识。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（三）我们仅允许有必要知晓这些信息的我们的员工、合作伙伴访问您的信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您的信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与我们的的合作关系。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（四）我们会采取一切合理可行的措施，确保未收集无关的信息。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（五）互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件或其他服务软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的信息安全。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（六）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（七）安全事件处置</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >在通过我们的服务与第三方进行沟通或购买商品及服务时，您不可避免的要向交易对方或潜在的交易对方披露自己的信息，如联络方式或者邮政地址等。请您妥善保护自己的信息，仅在必要的情形下向他人提供。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >为应对信息泄露、损毁和丢失等可能出现的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们也为安全事件建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >在不幸发生信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报信息安全事件的处置情况。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >五、如何管理您的信息</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（一）访问、更新和删除</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >我们鼓励您更新和修改您的信息以使其更准确有效。您能通过我们的服务访问您的信息，并根据对应信息的管理方式自行完成或要求我们进行修改、补充和删除。我们将采取适当的技术手段，尽可能保证您可以访问、更新和更正自己的信息或使用我们的服务时提供的其他信息。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑"
              >在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障信息安全。对于通过</span
            >COOKIES和WEB
            BEACON收集的您的信息，我们还在本《隐私政策》第二条“COOKIES、日志档案和WEB
            BEACON”部分说明了向您提供的选择机制。如您想查询、修改或删除您的部分信息，请登录我们的帐号中心或按照单项服务的具体指引进行操作。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（二）公开与分享</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >我们的多项服务可让您不仅与您的社交网络、也与使用该服务的所有用户公开分享您的相关信息，例如，您在我们的服务中所上传或发布的信息、您对其他人上传或发布的信息作出的回应，通过电子邮件或在我们的服务中不特定用户可见的公开区域内上传或公布您的个人信息，以及包括与这些信息有关的位置数据和日志信息。只要您不删除您所公开或共享的信息，有关信息可能一直留存在公众领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公众领域保存。如您将信息通过上述渠道公开或共享，由此造成您的信息泄露，我们不承担责任。因此，我们提醒并请您慎重考虑是否通过上述渠道公开或共享您的信息。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（三）注销</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >在符合我们的单项服务的服务协议约定条件及国家相关法律法规规定的情况下，您的该项我们的服务帐号可能被注销或删除。当帐号注销或被删除后，与该帐号相关的、该单项服务项下的全部服务资料和数据将依照单项服务的服务协议约定删除或处理。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（四）改变您授权同意的范围</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >您总是可以选择是否披露信息。有些信息是使用我们的服务所必需的，但大多数其他信息的提供是由您决定的。您可以通过删除信息、关闭设备功能等方式改变您授权我们继续收集信息的范围或撤回您的授权。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >当您撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的信息处理。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >（五）有关敏感信息的提示</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >某些信息因其特殊性可能被认为是敏感信息，例如您的种族、宗教、个人健康和医疗信息等，以及身份证明文件、个人生物识别信息、财产信息、行踪轨迹、未成年人的信息等。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >请注意，您在我们的服务中所提供、上传或发布的内容和信息（例如有关您社交活动的照片或信息），可能会泄露您的敏感信息。您需要谨慎地考虑，是否使用我们的服务披露您的敏感信息。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >您同意您的敏感信息按本《隐私政策》所述的目的和方式来处理。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >六、第三方服务</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >我们的服务可能链接至第三方提供的社交媒体或其他服务（包括网站或其他服务形式）。包括：</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >1）您可利用“分享”键将某些内容分享到我们的服务，或您可利用第三方服务登录我们的服务。这些功能可能会收集您的信息（包括您的日志信息），并可能在您的电脑装置COOKIES，从而正常运行上述功能；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >2）我们通过广告或我们服务的其他方式向您提供链接，使您可以接入第三方的服务或网站；</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑">（</span
            >3）其他接入第三方服务的情形。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >该等第三方社交媒体或其他服务由相关的第三方负责运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何信息），须受第三方自己的服务条款及信息保护声明（而非本《隐私政策》）约束，您需要仔细阅读其条款。本《隐私政策》仅适用于我们所收集的任何信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，而我们对任何第三方使用由您提供的信息不承担任何责任。</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14pxfont-family:微软雅黑"
            >七、如何联系我们</span
          >
        </p>
        <p style=";text-indent: 0;padding: 0">
          <span
            style="font-family: 微软雅黑;color: rgb(94, 94, 94);letter-spacing: 0;font-size: 14px"
            ><span style="font-family:微软雅黑"
              >如您有关于网络信息安全的投诉和举报，或您对本《隐私政策》、您的信息的相关事宜有任何问题、意见或建议，以及有关本声明或我们的的隐私措施的问题请与我们的的协调人联系。联系方式</span
            >400-022-1010。</span
          >
        </p>
      </template>
      <!-- 企业-租赁协议 -->
      <template v-else-if="type == 7">
        <img
        src="@/assets/images/7.png"
      /></template>
    <!-- 企业-购买协议 -->
       <template v-else-if="type == 8">
        <img
        src="@/assets/images/8.png"
      /></template>
      <template v-else-if="type == 9">
        <!-- 侨行云商 -->
        <h1>隐私政策</h1>
        <h3>本隐私政策于2021年11月25发布并生效</h3>
        <p>前言：</p>
        <p>
          侨行天下（杭州）商贸有限公司及旗下软件或各关联公司（以下统称“侨行云商”或“我们”）一向庄严承诺保护使用侨行云商的产品和服务（以下统称“侨行云商服务”或“我们的服务”）之用户（以下统称“用户”或“您”）的隐私。您在使用侨行云商服务时，我们可能会收集和使用您的相关信息。
        </p>
        <p>
          本《隐私政策》适用于我们提供的一切侨行云商服务。当您使用我们任何单项服务时，您同意接受本《隐私政策》以及我们在该单项服务中发出的特定隐私信息类政策条款（下列称“特定条款”）的保护，在此情况下特定条款与本政策条款同时对您产生效力。
        </p>
        <p>
          请注意我们不时地会检查我们的政策，因此有关的措施会随之变化。我们恳请您定期光顾本页面，以确保对我们《隐私政策》最新版本始终保持了解。当我们的隐私政策发生变化时，我们会在APP启动时以弹窗页面告知用户隐私政策已作更新，并提供入口到更新后的隐私政策页面。
        </p>
        <p>一、我们可能收集的信息</p>
        <p>（一）与个人身份无关的信息：</p>
        <p>
          当您使用我们的服务时，我们可能收集和汇总诸如用户的来源途径、访问顺序等信息，例如记录使用我们的服务的每个用户的来源途径、浏览器软件等。
        </p>
        <p>（二）有关个人身份的信息：</p>
        <p>
          当您使用我们的服务时，我们可能收集和汇总或要求您提供有关个人身份的信息，例如个人身份证明（包括身份证、护照、驾驶证等）；生日、籍贯、性别、兴趣爱好、个人电话号码、面部特征；网络身份标识信息（包括系统账号、IP地址、电子邮箱地址及与前述有关的密码、口令、口令保护答案等）；个人财产信息（交易记录、余额、优惠券、银行卡信息等）；通讯信息；个人上网记录和日志信息（包括网站浏览记录、软件使用记录、点击记录、操作日志等）；设备信息（包括设备型号、设备MAC地址、操作系统类型、设备设置）；软件列表唯一设备识别码（如IMEI/android
          ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息）；位置信息（包括行程信息、精准定位信息、住宿信息、经纬度等）。
        </p>
        <p>
          我们收集您的信息主要是为了您和其他用户能够更容易和更满意地使用我们的服务。我们的目标是向所有的互联网用户提供安全、刺激、有趣及有教益的上网经历。而这些信息有助于我们实现这一目标。
        </p>
        <p>
          请注意，如您在我们的服务中其他用户可见的公开区域内上传或发布的信息中、您对其他人上传或发布的信息作出的回应中公开您的个人信息，该等信息可能会被他人收集并加以使用。
        </p>
        <p>二、我们如何收集和使用信息</p>
        <p>（一）我们将通过以下途径收集和获得您的信息：</p>
        <p>1、您提供的信息。 例如：</p>
        <p>
          （1）您在注册我们的服务的帐号或使用我们的服务时，向我们提供的信息；
        </p>
        <p>
          （2）您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。
        </p>
        <p>
          2、其他方分享的您的信息。亦即其他方使用我们的服务时所提供有关您的共享信息。
        </p>
        <p>
          3、我们获取的您的信息。您在使用我们的服务时，我们收集、汇总、记录的信息，例如日志信息、位置信息、设备信息等。
        </p>
        <table border="1">
          <tbody>
            <tr>
              <td>
                <p>收集、汇总、记录的信息</p>
              </td>
              <td>
                <p>相关用途</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>手机储存</p>
              </td>
              <td>
                <p>用于下载app，上传头像</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>电话</p>
              </td>
              <td>
                <p>用于拨打客服电话</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>相机</p>
              </td>
              <td>
                <p>用于上传或更换头像</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>日志信息</p>
              </td>
              <td>
                <p>用于对接的三方服务</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>位置信息</p>
              </td>
              <td>
                <p>用于对接的三方服务</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>设备信息</p>
              </td>
              <td>
                <p>用于对接的三方服务</p>
              </td>
            </tr>
          </tbody>
        </table>
        <p>&nbsp;</p>
        <p>（二）我们会出于以下目的，收集和使用您的信息：</p>
        <p>1、帮助您完成注册</p>
        <p>
          为便于我们为您提供服务，您需要提供基本注册信息，例如手机号码、电子邮箱地址等，并创建您的用户名和密码。在部分单项服务中，如果您仅需使用浏览、搜索等基本服务，您不需要注册成为我们的用户及提供上述信息。
        </p>
        <p>2、向您提供商品或服务</p>
        <p>
          我们所收集和使用的信息是为您提供我们的服务的必要条件，如缺少相关信息，我们将无法为您提供我们的服务的核心内容，例如：
        </p>
        <p>
          （1）在部分服务项目中，为便于向您交付商品或服务，您需提供收货人个人身份信息、姓名、收货地址、邮政编码、收货人、联系电话、支付状态等信息。如果您拒绝提供此类信息，我们将无法完成相关交付服务。如您通过我们的服务为其他人订购商品或服务，您需要提供该实际订购人的前述信息。向我们提供该实际订购人的前述信息之前，您需确保您已经取得其授权同意。
        </p>
        <p>
          （2）为展示您账户的订单信息，我们会收集您在使用我们的服务过程中产生的订单信息用于向您展示及便于您对订单进行管理；
        </p>
        <p>
          （3）当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。
        </p>
        <p>
          （4）为确认交易状态及为您提供售后与争议解决服务，我们会通过您基于交易所选择的交易对象、支付机构、物流公司等收集与交易进度相关的您的交易、支付、物流信息，或将您的交易信息共享给上述服务提供者。
        </p>
        <p>3、为您提供安全保障</p>
        <p>
          为确保您身份真实性、向您提供更好的安全保障，您可以向我们提供身份证明、面部特征等生物识别信息等个人敏感信息以完成实名认证。
        </p>
        <p>
          除身份验证外，我们可能将您的信息用于客户服务、安全防范、诈骗监测、存档和备份等用途，确保我们向您提供的服务的安全性；我们可能使用或整合我们所收集的您的信息，以及我们的合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
        </p>
        <p>4、改进我们的服务</p>
        <p>
          我们可能将通过某一项我们的服务所收集的信息，用于我们的其他服务。例如，在您使用某一项我们的服务时所收集的您的信息，可能在另一项我们的服务中用于向您提供特定内容或向您展示与您相关的、而非普遍推送的信息；我们可能让您参与有关我们的服务的调查，帮助我们改善现有服务或设计新服务；同时，我们可能将您的信息用于软件更新。
        </p>
        <p>
          您了解并同意，在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别您的身份，在此情况下我们有权使用已经去标识化的信息，对用户数据库进行分析并予以商业化的利用。
        </p>
        <p>
          如果我们将您的信息用于本《隐私政策》中未载明的其他用途，会事先征求您同意。
        </p>
        <p>5、征得授权同意的例外</p>
        <p>
          根据相关法律法规规定，以下情形中收集您的信息无需征得您的授权同意：
        </p>
        <p>（1）与国家安全、国防安全有关的；</p>
        <p>（2）与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>（3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
        <p>
          （4）出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
        </p>
        <p>（5）所收集的信息是您自行向社会公众公开的；</p>
        <p>
          （6）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；
        </p>
        <p>（7）根据您的要求签订合同所必需的；</p>
        <p>
          （8）用于维护我们的服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
        </p>
        <p>（9）为合法的新闻报道所必需的；</p>
        <p>
          （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；
        </p>
        <p>（11）法律法规规定的其他情形。</p>
        <p>三、我们可能分享、转让或披露的信息</p>
        <p>（一）分享</p>
        <p>
          除以下情形外，未经您同意，我们不会与之外的任何第三方分享您的信息：
        </p>
        <p>
          1、向您提供我们的服务。我们可能向合作伙伴及其他第三方分享您的信息，以实现您需要的核心功能或提供您需要的服务包括：数据统计功能；
        </p>
        <p>（1）数据统计终端统计分析服务</p>
        <p>【友盟+】终端统计分析服务（U-App/U-Web）</p>
        <p>
          【友盟+】统计分析服务帮助我们了解我们的最终用户如何使用我们的产品（含服务，包括但不限于移动应用客户端、移动网站、应用平台、PC网站、站点及【友盟+】确认可提供服务的其他终端等，以下同），并且帮助我们分析我们的产品在不同终端设备上的表现。当我们在产品里集成了【友盟+】统计分析工具之后，我们的产品就通过【友盟+】统计分析工具收集和传送数据到友盟的服务器。友盟收集唯一设备识别码（IMEI/Mac/android
          ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。
        </p>
        <p>
          除上述个人信息外，统计分析服务将根据统计维度的不同采集如下信息：SDK/API/JS代码版本、浏览器、互联网服务提供商、平台、时间戳、应用标识符、应用程序版本、应用分发渠道、独立设备标识符、设备型号、传感器参数、终端制造厂商、终端设备操作系统版本、会话启动/停止时间、语言所在地、时区和网络状态（WiFi等）、硬盘、CPU和电池使用情况等。
        </p>
        <p>
          2、维护和改善我们的服务。我们可能向合作伙伴及其他第三方分享您的信息，以帮助我们为您提供更有针对性、更完善的服务，例如：代表我们发出电子邮件或推送通知的通讯服务提供商等；
        </p>
        <p>3、实现本《隐私政策》第二条“我们如何收集和使用信息”部分所述目的；</p>
        <p>
          4、履行我们在本《隐私政策》或我们与您达成的其他协议中的义务和行使我们的权利；
        </p>
        <p>
          5、向委托我们进行推广的合作伙伴等第三方共享，但我们仅会向这些委托方提供推广的覆盖面和有效性的信息，而不会提供可以识别您身份的信息，例如姓名电话号码或电子邮箱；或者我们将这些信息进行汇总，以便它不会识别您个人。比如我们可以告知该委托方有多少人看了他们的推广信息或在看到这些信息后购买了委托方的商品，或者向他们提供不能识别个人身份的统计信息，帮助他们了解其受众或顾客。
        </p>
        <p>
          6、在法律法规允许的范围内，为了遵守法律、维护我们及我们的关联方或合作伙伴、您或其他我们的用户或社会公众利益、财产或安全免遭损害，比如为防止欺诈等违法活动和减少信用风险，我们可能与其他公司和组织交换信息。不过,这并不包括违反本《隐私政策》中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的信息。
        </p>
        <p>7、应您合法需求，协助处理您与他人的纠纷或争议；</p>
        <p>8、应您的监护人合法要求而提供您的信息；</p>
        <p>
          9、根据与您签署的单项服务协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；
        </p>
        <p>10、基于学术研究而提供；</p>
        <p>11、基于符合法律法规的社会公共利益而提供。</p>
        <p>
          我们仅会出于合法、正当、必要、特定、明确的目的共享您的信息。对我们与之共享信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本《隐私政策》以及其他任何相关的保密和安全措施来处理信息。
        </p>
        <p>（二）转让</p>
        <p>
          1、随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而您的信息有可能作为此类交易的一部分而被转移。我们会要求新的持有您信息的公司、组织继续受本《隐私政策》的约束，否则,我们将要求该公司、组织重新向您征求授权同意。
        </p>
        <p>2、在获得您的明确同意后，我们会向其他方转让您的信息。</p>
        <p>（三）披露</p>
        <p>
          我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会披露您的信息：
        </p>
        <p>1、根据您的需求，在您明确同意的披露方式下披露您所指定的信息；</p>
        <p>
          2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您信息的情况下，我们可能会依据所要求的信息类型和披露方式披露您的信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。
        </p>
        <p>四、我们如何保留、储存和保护信息</p>
        <p>
          我们仅在本《隐私政策》所述目的所必需期间和法律法规要求的时限内保留您的信息。
        </p>
        <p>我们在中华人民共和国境内运营中收集和产生的信息，存储在中国境内。</p>
        <p>我们将采取以下手段保护您的信息：</p>
        <p>（一）数据安全技术措施</p>
        <p>
          我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失。网络服务采取了多种加密技术，例如在某些服务中，我们将利用加密技术（例如SSL）来保护您的信息，采取加密技术对您的信息进行加密保存，并通过隔离技术进行隔离。
          在信息使用时，例如信息展示、信息关联计算，我们会采用多种数据脱敏技术增强信息在使用中安全性。采用严格的数据访问权限控制和多重身份认证技术保护信息，避免数据被违规使用。
        </p>
        <p>（二）我们为保护信息采取的其他安全措施</p>
        <p>
          我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范信息的存储和使用。
        </p>
        <p>
          我们通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。
        </p>
        <p>
          加强安全意识。我们还会举办安全和隐私保护培训课程，加强员工对于保护信息重要性的认识。
        </p>
        <p>
          （三）我们仅允许有必要知晓这些信息的我们的员工、合作伙伴访问您的信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您的信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与我们的的合作关系。
        </p>
        <p>（四）我们会采取一切合理可行的措施，确保未收集无关的信息。</p>
        <p>
          （五）互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件或其他服务软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的信息安全。
        </p>
        <p>
          （六）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
        </p>
        <p>（七）安全事件处置</p>
        <p>
          在通过我们的服务与第三方进行沟通或购买商品及服务时，您不可避免的要向交易对方或潜在的交易对方披露自己的信息，如联络方式或者邮政地址等。请您妥善保护自己的信息，仅在必要的情形下向他人提供。
        </p>
        <p>
          为应对信息泄露、损毁和丢失等可能出现的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们也为安全事件建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。
        </p>
        <p>
          在不幸发生信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报信息安全事件的处置情况。
        </p>
        <p>
          请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。
        </p>
        <p>五、如何管理您的信息</p>
        <p>（一）访问、更新和删除</p>
        <p>
          我们鼓励您更新和修改您的信息以使其更准确有效。您能通过我们的服务访问您的信息，并根据对应信息的管理方式自行完成或要求我们进行修改、补充和删除。我们将采取适当的技术手段，尽可能保证您可以访问、更新和更正自己的信息或使用我们的服务时提供的其他信息。
        </p>
        <p>
          在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障信息安全。对于通过COOKIES和WEB
          BEACON收集的您的信息，我们还在本《隐私政策》第二条“COOKIES、日志档案和WEB
          BEACON”部分说明了向您提供的选择机制。如您想查询、修改或删除您的部分信息，请登录我们的帐号中心或按照单项服务的具体指引进行操作。
        </p>
        <p>（二）公开与分享</p>
        <p>
          我们的多项服务可让您不仅与您的社交网络、也与使用该服务的所有用户公开分享您的相关信息，例如，您在我们的服务中所上传或发布的信息、您对其他人上传或发布的信息作出的回应，通过电子邮件或在我们的服务中不特定用户可见的公开区域内上传或公布您的个人信息，以及包括与这些信息有关的位置数据和日志信息。只要您不删除您所公开或共享的信息，有关信息可能一直留存在公众领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公众领域保存。如您将信息通过上述渠道公开或共享，由此造成您的信息泄露，我们不承担责任。因此，我们提醒并请您慎重考虑是否通过上述渠道公开或共享您的信息。
        </p>
        <p>（三）注销</p>
        <p>
          在符合我们的单项服务的服务协议约定条件及国家相关法律法规规定的情况下，您的该项我们的服务帐号可能被注销（注销设置路径：“我的”——“个人设置”——“注销”）。当帐号注销后，与该帐号相关的、该单项服务项下的全部服务资料和数据将依照单项服务的服务协议约定删除或处理。
        </p>
        <p>（四）改变您授权同意的范围</p>
        <p>
          您总是可以选择是否披露信息。有些信息是使用我们的服务所必需的，但大多数其他信息的提供是由您决定的。您可以通过删除信息、关闭设备功能等方式改变您授权我们继续收集信息的范围或撤回您的授权。
        </p>
        <p>
          当您撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的信息处理。
        </p>
        <p>（五）有关敏感信息的提示</p>
        <p>
          某些信息因其特殊性可能被认为是敏感信息，例如您的种族、宗教、个人健康和医疗信息等，以及身份证明文件、个人生物识别信息、财产信息、行踪轨迹、未成年人的信息等。
        </p>
        <p>
          请注意，您在我们的服务中所提供、上传或发布的内容和信息（例如有关您社交活动的照片或信息），可能会泄露您的敏感信息。您需要谨慎地考虑，是否使用我们的服务披露您的敏感信息。
        </p>
        <p>您同意您的敏感信息按本《隐私政策》所述的目的和方式来处理。</p>
        <p>六、其他第三方服务</p>
        <p>
          侨行云商可能接入或链接至第三方提供的社交媒体或其他服务（包括网站或其他服务形式）。包括：
        </p>
        <p>
          1、您可利用“分享”键将某些侨行云商服务内容分享到第三方服务，或您将第三方服务内容分享到侨行云商服务。这些功能可能会收集您的信息（包括您的日志信息），并可能在您的设备内装置COOKIES，从而正常运行上述功能；
        </p>
        <p>
          2、我们通过我们服务的其他方式向您提供链接，使您可以链接至第三方的服务或网站；
        </p>
        <p>
          3、其他接入第三方服务的情形。例如，为实现本政策中声明的目的，我们可能会接入第三方服务商提供的SDK或其他类似的应用程序（如以嵌入代码、插件等形式），以便向您提供更好的客户服务和用户体验。目前，我们接入的第三方服务商主要包括以下几种类型：
        </p>
        <p>
          （1）用于数据监测/统计、分享等；
        </p>
        <p>
          （2）用于在您同意的情况下获取设备位置权限、搜集设备信息和日志信息等；
        </p>
        <p>
          （3）用于第三方授权服务，包括第三方帐号登陆、将有关内容分享至第三方产品等；
        </p>
        <p>
          （4）用于帐号安全、产品加固相关服务，包括网络监测、域名解析、防劫持、反垃圾反作弊、加解密服务等。
        </p>
        <p>
          我们接入的部分第三方SDK或类似应用程序可能会收集您的个人信息，如您在我们的服务中使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息。我们会评估这类第三方服务收集个人信息的合法性、正当性、必要性，要求该等第三方对您的个人信息采取保护措施，并严格遵守相关法律法规与监管要求。您可以查看《第三方SDK目录》，了解我们主要接入的第三方SDK基本情况，各单项服务接入第三方SDK的情况可能有不同，如需了解具体单项服务接入第三方SDK的详细情况，请您前往对应的服务页面并查阅我们各单项服务的具体条款和相关页面。您也可以选择通过本政策“如何联系我们”章节所列的反馈渠道联系我们，我们会尽快为您作出解答。
        </p>
        <p>七、如何联系我们</p>
        <p>
          如您有关于网络信息安全的投诉和举报，或您对本《隐私政策》、您的信息的相关事宜有任何问题、意见或建议，以及有关本声明或我们的的隐私措施的问题请与我们的的协调人联系。联系方式400-022-1010。
        </p>
        <h3>本隐私政策修订于2022年2月25日</h3>
      </template>
      <template v-else-if="type == 10">
        <!-- 侨行云商协议 -->
        <h1>用户使用协议</h1>
        <p>
          <span class="font-size-small">重要提示：</span>
        </p>
        <p>
          <span class="font-size-small"
            >本服务协议为侨行天下（杭州）商贸有限公司（以下称“本公司”）与您签订。在您通过本公司系统（本公司系统：手机端：侨行云商APP）注册成为本公司的用户前请务必仔细阅读以下条款。若您完成本公司系统指定的注册流程，则表示您同意接受本公司的服务并受以下条款的约束。若您不接受以下条款，请您立即停止注册或使用本公司的服务。</span
          >
        </p>
        <p>
          <span class="font-size-small">第一章&nbsp;特别提醒</span>
        </p>
        <p>
          <span class="font-size-small"
            >第一条&nbsp;本公司只接受持有中国（不含港澳台地区）有效身份证明的18周岁以上具有完全民事行为能力的自然人成为注册用户。如您不符合资格，请勿注册，否则本公司有权随时中止或终止您的用户资格，因此所导致的任何后果甶您个人承担。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第二条&nbsp;本协议内容包括以下条款及本公司系统上已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的一部分，与协议正文具有同等法律效力。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第三条&nbsp;本公司有权根据需要不时地修改本协议或根据本协议制定、修改各类具体规则并在本公司相关系统板块上发布，无需另行单独通知您。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >(1)如您不同意变更后的协议及相关规则内容，应立即停止通过本公司系统进行所有交易。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >(2)若您在本协议及具体规则内容公告变更后继续使用本公司服务的，表示您已充分阅读、理解并接受修改后的协议和具体规则内容；同时就您在协议和具体规则修订前通过本公司系统进行的交易及其效力，视为您已同意并已按照本协议及有关规则进行了相应的授权和追认。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第四条在您注册成为用户时，您已经阅读、理解并接受本协议的全部条款及各类规则，如有违反而导致任何法律后果的发生，您将以自己的名义独立承担相应的法律责任。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第五条您同意以网络页面点击确认的方式签署本协议，并不以此为由拒绝履行本协议及协议下的规则上约定的义务。在您点击确认本协议后，本协议即在您和本公司之间产生法律效力。</span
          >
        </p>
        <p>
          <span class="font-size-small">第二章&nbsp;风险告知</span>
        </p>
        <p>
          <span class="font-size-small"
            >您作为注册用户使用本公司系统时，已知悉通过本公司系统进行相关交易可能存在诸多风险，包括但不限于以下风险：</span
          >
        </p>
        <p>
          <span class="font-size-small">第一条&nbsp;政策风险</span>
        </p>
        <p>
          <span class="font-size-small"
            >甶于国家法律、法规、政策的变化，紧急措施的出台，相关监管部门监管措施的实施，交易所交易规则的修改等原因，均可能会对您的交易产生影响，您必须承担由此导致的损失。</span
          >
        </p>
        <p>
          <span class="font-size-small">第二条&nbsp;技术风险</span>
        </p>
        <p>
          <span class="font-size-small"
            >本公司所提供的服务系通过电子通讯技术和互联网技术来实现。可能会存在品质和稳定性方面的风险，通讯或网络故障导致的某些服务中断或延时，另外您的电脑系统或手机APP端也可能会甶于网络信息或者病毒或网络黑客攻击等不确定因素，有可能会给您的交易带来一定影响。</span
          >
        </p>
        <p>
          <span class="font-size-small">第三条&nbsp;不可抗力风险</span>
        </p>
        <p>
          <span class="font-size-small"
            >本公司提供的服务在遇到地震、水灾、火灾、暴动、罢工、战争、政府管制、国内外的禁止或限制以及停电、技术故障、电子故障等其他无法预测和防范的不可抗力事件时，都有可能会对您的交易产生影响或造成其损失。</span
          >
        </p>
        <p>
          <span class="font-size-small">第三章&nbsp;用户信息及账户安全</span>
        </p>
        <p>
          <span class="font-size-small">第一条&nbsp;用户注册及验证</span>
        </p>
        <p>
          <span class="font-size-small"
            >(1)您在本公司的注册采用实名认证，您应保证提供的姓名、联系电话、联系地址、电子邮件地址等内容的真实性、安全性和有效完整性，以便本公司为您提供服务时能及时与您取得联系。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >(2)您同意本公司自行或通过合作的第三方机构对您提交或本公司搜集的用户信息（包括但不限于您的个人身份证信息等）进行核实，并对获得的核实结果根据本协议及有关文件进行查看、使用和留存等操作。若甶于您信息不真实、完整的，我公司有权暂停或终止您的注册申请。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >(3)若您的信息变更的，应及时联系侨行云商客服（客服电话：4002188686)及时办理变更手续。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >若甶于您未能及时更新个人信息导致本公司为您提供的服务过程中遭受损失或增加费用等的，甶您本人承担相应的不利后果;若由此给我公司及其他关联公司造成损失的，您应承担相应的赔偿责任。</span
          >
        </p>
        <p>
          <span class="font-size-small">第二条&nbsp;账户安全</span>
        </p>
        <p>
          <span class="font-size-small"
            >(1)您的账号仅限本人使用，不可转让及赠送。您确认，无论是您还是您的代理人，用您的用户名和密码登录本公司系统后在本公司的一切行为均代表您并由您承担相应的法律后果。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >(2)您有义务保管好账号、密码等个人信息：</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >若您发现有第三人冒用或盗用您的用户账户及密码，或其他任何未经合法授权的情形，应立即通知本公司，要求本公司暂停相关服务，否则由此产生的一切责任由您本人承担。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >(3)您须仔细甄别确认为本公司的系统后再登陆，因您不慎误登录钓鱼网站等非正规网站而导致的经济损失，由您自行承担。</span
          >
        </p>
        <p>
          <span class="font-size-small">第三条&nbsp;隐私保护</span>
        </p>
        <p>
          <span class="font-size-small"
            >（1）您同意并授权本公司将您的包括但不限于真实姓名、联系方式等必要的个人信息和交易信息披露给与您交易的另一方或本公司的合作机构（仅限于本公司为完成拟向您提供的服务而合作的机构）。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >（2）本公司有义务根据有关法律要求向司法机关和政府部门提供您的个人资料。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >（3）您同意接收本公司以电子邮件或短信形式向其手机（手机号码、邮件地址）发布促销等信息（接收短信不收取任何费用。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >（4）本公司对于您提供的、自行收集到的、经认证的个人信息将按照本协议及有关规则予以保护、使用或者披露。本公司将保护您的个人资料，但鉴于技术限制，本公司不能确保您的全部私人通讯及其他个人资料不被相关方以其他方式获取。</span
          >
        </p>
        <p>
          <span class="font-size-small">第四章&nbsp;提供的服务</span>
        </p>
        <p>
          <span class="font-size-small"
            >第一条&nbsp;本公司提供的服务包括但不限于：进口商品与一般商品的浏览与购买，具体详情以本公司当时提供的服务内容为准。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第二条&nbsp;基于运行和交易安全的需要，本公司可暂时停止提供、限制或改变本公司服务的部分功能，或提供新的功能。在任何功能变化时，只要您仍然使用本公司提供的服务，表示您同意本协议或变更后的协议。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第三条&nbsp;您在本公司系统上按相应的服务流程所确认的交易状态将成为本公司为您进行相关交易或操作（包括但不限于冻结资金、代为支付或收取款项、订立合同等）的明确指令。您同意本公司有权按相关指令依据本协议和/或有关文件和规则对相关事项进行处理。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第四条&nbsp;您未能及时对交易状态进行修改或确认或未能提交相关申请所引起的任何纠纷或损失甶您本人负责，本公司不承担任何责任。</span
          >
        </p>
        <p>
          <span class="font-size-small">第五章&nbsp;货品运输及退换货</span>
        </p>
        <p>
          <span class="font-size-small"
            >第一条&nbsp;在您购买商品交易完成后，因原料环节、生产环节、物流环节或其他非本公司主观原因导致您无法按本公司系统上声明的规定时间收到商品的，本公司不承担相关责任。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第二条&nbsp;本公司所有商品通过系统规定的方式发送至您确定的收货地址，包括但不限于快递、普通邮寄等。如您对货品产生疑问的，请当场拒收。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第三条&nbsp;本公司所有商品，除特别说明、特殊商品外，均支持七天无理由退换货。</span
          >
        </p>
        <p>
          <span class="font-size-small">第六章&nbsp;免责条款</span>
        </p>
        <p>
          <span class="font-size-small"
            >第一条&nbsp;您同意，本公司不能保证也没有义务保证第三方网站上的信息的真实性、准确性和有效性。您应按照第三方网站的服务协议使用第三方网站，而不是按照本协议。第三方网站的内容、产品、广告和其他任何信息均甶您自行判断并承担风险，而与本公司无关。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第二条&nbsp;鉴于技术及设备的局限性，因为本公司或者涉及的第三方网站的设备、系统存在缺陷、被黑客攻击、出现网络故障、</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >电力中断、计算机病毒或其他不可抗力因素造成的损失，本公司不承担相应的赔偿责任，您可以与本公司协商终止本协议并停止使用本公司系统。但是，中国现行法律、法规另有规定的除外。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第三条&nbsp;在任何情况下，对于您使用本公司服务过程中涉及由第三方提供相关服务的责任由该第三方承担，本公司不承担该等责任。因您自身的原因导致本公司服务无法提供或提供时发生任何错误而产生的任何损失或责任，甶您自行负责，本公司不承担责任。</span
          >
        </p>
        <p>
          <span class="font-size-small">第十章&nbsp;使用限制</span>
        </p>
        <p>
          <span class="font-size-small"
            >第一条&nbsp;您承诺合法使用本公司提供的服务及内容。您不得利用本公司系统从事侵害他人合法权益的行为、或违法违规之行为、或任何未经授权的行为等。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第二条&nbsp;由于您违反本协议或法律、法规或侵害第三方的权利，而引起第三方对本公司提出的任何形式的索赔、权利主张或要求、诉讼，本公司有权向您追偿相关的直接损失或间接损失，包括但不限于本公司因此支付的法律服务等中介费用、名誉损失、及向第三方支付的补偿金、损害赔偿金等。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第十一章&nbsp;协议终止及账户的暂停、注销或终止</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第一条&nbsp;除非本公司终止本协议或者您申请终止本协议且经本公司同意，否则本协议始终有效。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第二条&nbsp;您决定不再使用用户账户时，应首先清偿所有应付款项（包括但不限于服务费、管理费等），再将用户账户中的可用款项（如有）全部提现或者向公司系统发出其它合法的支付指令，并向本公司申请注销该用户账户，经本公司审核同意后可正式注销用户账户。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >注册会员死亡或被宣告死亡的，其在本协议项下的各项权利义务由其继承人承担。若注册会员丧失全部或部分民事权利能力或民事行为能力，本公司有权根据有效法律文书（包括但不限于生效的法院判决等）或其法定监护人的指示处置与用户账户相关的款项。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第三条&nbsp;如发生如下情形的，您认可，本公司有权基于单方独立判断在认为可能发生危害交易安全等情形时，可先行暂停、中断或终止向您提供本协议项下的全部或部分服务，且无需对您或任何第三方承担任何责任。前述情形包括但不限于：</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >（1）本公司认为您提供的个人资料不具有真实性、有效性或完整性；</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >（2）您使用本公司服务的行为涉嫌违反国家法律法规及行政规定的；</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >（3）本公司发现异常交易或有疑义或有违法之虞时；</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >（4）本公司认为您的账户涉嫌洗钱、套现、传销、被冒用或其他本公司认为有风险之情形；或认为账户操作、资金进出等存在异常时；</span
          >
        </p>
        <p>
          <span class="font-size-small">（5）本公司收到有权机关的要求；</span>
        </p>
        <p>
          <span class="font-size-small"
            >（6）您受到第三方的投诉，且对方已经提供了一定证据的；</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >（7）本公司认为您已经违反本协议之内容；</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >（8）本公司基于交易安全等原因，需先行暂停、中断或终止向您提供本协议项下的全部或部分会员服务，并将注册资料移除或删除的其他情形。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >（9）在您违反了本协议及相关规则，或在相关法律法规、政府部门的要求下，本公司有权通过电子邮件通知或短信的等方式终止本协议、关闭您的账户或者限制您使用本公司系统。但本公司的终止行为不能免除您根据本协议或在本公司系统上生成的其他协议项下的还未履行完毕的义务。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第四条&nbsp;您同意，在必要时，本公司无需进行事先通知即有权终止提供用户账户服务，并可能立即暂停、关闭或删除您的用户账户及该用户账户中的所有相关资料及档案，并将您滞留在这些</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >账户的全部合法资金退回到您的银行账户。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第五条&nbsp;您同意，用户账户的暂停、中断或终止不代表您在本协议项下及本公司相关交易行为中责任和义务的终止，您仍应对您使用本公司系统服务期间的行为承担可能的违约或损害赔偿责任，同时本公司仍可保有您的相关信息。</span
          >
        </p>
        <p>
          <span class="font-size-small">第十二章&nbsp;协议生效及变更</span>
        </p>
        <p>
          <span class="font-size-small"
            >第一条&nbsp;在不损害您利益的前提下，本公司保留修改或增补本协议内容的权利。本协议的修改文本将由本公司通过与业务内容相适应的方式进行公告或以其他本公司认为可行的方式通知。</span
          >
        </p>
        <p>
          <span class="font-size-small"
            >第二条&nbsp;本协议书生效后，若有关法律法规或其他本公司和您应共同遵守的法律依据发生修订，本协议与之不相适应的内容及条款自行失效，但本协议其他内容和条款继续有效。</span
          >
        </p>
        <p>
          <span class="font-size-small">第十三章&nbsp;通知及送达条款</span>
        </p>
        <p>
          <span class="font-size-small"
            >本协议项下的通知如以公示方式作出，一经在本公司系统上公示即视为已经送达。除此之外，其他向您个人发布的具有专属性的通知将由本公司向您在注册时提供的电子邮箱，或您在注册后绑定的手机发送，一经发送即视为已经送达。您同时同意并确认，若您设置了不接收有关通知或提醒，则您有可能无法收到该等通知信息，您不得以您未收到或未阅读该等通知信息主张相关通知未送达于您。</span
          >
        </p>
        <p>
          <span class="font-size-small">第十四章&nbsp;适用法律和争议解决</span>
        </p>
        <p>
          <span class="font-size-small"
            >本协议之效力、解释、变更、执行与因本公司所提供服务而产生的争议均适用中国法律，并由将争议提交杭州市仲裁委员会，依据该会届时有效的仲裁规则进行仲裁。仲裁裁决是终局裁决，对双方均有强制执行力。仲裁期间，本协议不涉及争议的条款应继续履行。</span
          >
        </p>
        <p>
          <span class="font-size-small">第十五章&nbsp;其他</span>
        </p>
        <p>
          <span class="font-size-small"
            >在法律法规允许的范围内，本公司对本协议享有修改权和最终解释权。本协议及本公司系统有关页面的相关名词可互相引用参照，如有不同理解，则以本协议条款为准。此外，若本协议的部分条款被认定为无效或者无法实施时，本协议中的其他条款仍效有效。</span
          >
        </p>
        <p>
          <span class="font-size-small">第十六章&nbsp;名词定义</span>
        </p>
        <p>
          <span class="font-size-small"
            >用户：是指向本公司系统进行交易的有民事主体资格的自然人（须在本公司系统上注册并通过实名认证并绑定银行卡）。</span
          >
        </p>
      </template>
      <template v-else-if="type == 11">
        <p style="text-align: center;">隐私权政策</p>
        <p>
          <strong><strong>简介&amp;提示</strong></strong>
        </p>
        <p>最新版本生效日期：2023年2月21日</p>
        <p>&nbsp;</p>
        <p>
          &nbsp; &nbsp; &nbsp;
          欢迎您使用我们的产品和服务！我们深知个人信息对您的重要性，您的信任对我们非常重要，我们将根据法律法规要求并参照行业最佳实践为您的个人信息安全提供充分保障。为此，潮韵拍卖服务提供者（或称&ldquo;<strong
            ><strong>我们</strong></strong
          >&rdquo;）制定本《隐私权政策》（下称&ldquo;本政策&rdquo;）以便您充分了解，在您使用潮韵拍卖的产品和服务的过程中，我们会如何收集、使用、共享、存储和保护您的个人信息，以及您可以如何管理您的个人信息。
        </p>
        <p>&nbsp;</p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;在您开始使用我们的产品和服务前，请您务必先仔细阅读和理解本政策，特别应重点阅读我们以<strong
            ><strong>粗体/粗体下划线</strong></strong
          >标识的条款，确保您充分理解和同意后再开始使用。本政策中涉及的专业词汇，我们尽量以简明通俗的表述向您解释，以便于您理解。
        </p>
        <p>&nbsp;</p>
        <p>本政策主要向您说明：</p>
        <p>
          <strong><strong>【我们如何收集和使用您的个人信息】</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;潮韵拍卖为您提供便捷的网上拍卖服务，为了实现服务的提供，我们主要会基于如下需要收集、使用、共享、存储您的个人信息：
        </p>
        <ul>
          <li>
            <strong><strong>账号注册</strong></strong
            >：您在访问我们的网站或小程序时，可匿名浏览拍品信息，但是您在参与竞拍等其他账号服务时，需要您注册潮韵拍卖的账号。
          </li>
          <li>
            <strong><strong>实名认证</strong></strong
            >：为了验证您的身份真实性，我们会使用第三方服务来验证您的身份信息。
          </li>
          <li>
            <strong><strong>订单自提</strong></strong
            >：您需要提供自提人的姓名和身份证号码信息，用于您来上门提货时，工作人员核验您的身份，保障您的订单安全。
          </li>
          <li>
            <strong><strong>订单邮寄</strong></strong
            >：您需要提供收货人、收货地址、联系电话信息，以便于我们安排物流公司发货，保障您的交易安全。
          </li>
          <li>
            <strong><strong>安全保障</strong></strong
            >：为保障您的账户及交易安全，我们需要收集和处理您的设备信息（IMEI、IMSI）、日志信息，我们也会将这些信息用于预防发生各类违法违规或其他主体合法权益被侵害的情况。
          </li>
        </ul>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;对于上述您的个人信息，大部分是由您主动向我们提供的，也有我们在您使用我们的产品或服务时通过Cookies、SDK及类似技术获取的，还有部分是从第三方间接获取的。
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;我们希望您能理解，我们无法单独向您提供上述全部的服务，很多时候我们还需要同我们的关联公司以及其他的服务提供商一起为您提供这些服务，因此，为满足为您提供上述服务的必要，我们需要向我们的关联公司、供应商、合作伙伴及其他第三方以共享或委托处理的方式提供您的部分个人信息。向上述各方提供您的个人信息的时候，我们会采取必要的技术和管理措施尽可能地保护您的个人信息安全。
        </p>
        <p>&nbsp;</p>
        <p>
          <strong><strong>【您如何管理自己的信息】</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;您可以通过多种方式管理您的个人信息，例如更新您的个人信息、管理系统权限等。如果您在管理您的个人信息时遇到问题，您还可以通过以下联系方式与我们联系，我们将在15天内回复您的要求。但也请您理解，我们可能会因为履行法律法规义务或者我们提供服务必要性的原因无法完全满足您的请求。
        </p>
        <p>&nbsp;</p>
        <p>
          <strong><strong>【联系我们】</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;如您对本政策有任何疑问、意见或建议，或者您在管理您的个人信息时遇到任何问题，您可通过我们提供的多种反馈渠道与我们联系：
        </p>
        <p>
          1、您的个人信息相关咨询、投诉问题，可通过潮韵拍卖客服与我们取得联系。
        </p>
        <p>
          2、如您对本政策内容有任何疑问、意见或建议，可与我们客服联系，联系方式：18058734691。
        </p>
        <p>
          3、如您发现个人信息因为我们的原因可能被泄露，您可以直接通过潮韵拍卖客服发起投诉举报。
        </p>
        <p>
          4、浙江潮韵拍卖有限公司，注册地址:浙江省嘉兴市南湖区东栅街道富兴路286号1幢6楼617-5室。
        </p>
        <p>&nbsp;</p>
        <p>
          <strong><strong>隐私权政策</strong></strong>
        </p>
        <p>最新版本生效日期：2023年2月21日</p>
        <p>
          <strong><strong>【引言】</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;欢迎您使用我们的产品和服务！我们深知个人信息对您的重要性，您的信赖对我们非常重要，我们将严格遵守法律法规要求采取相应的安全保护措施，致力于保护您的个人信息安全。基于此，潮韵拍卖服务提供者（或简称&ldquo;<strong
            ><strong>我们</strong></strong
          >&rdquo;）制定本《隐私权政策》（下称&ldquo;本政策&ldquo;），帮助您充分了解在您使用我们产品和服务的过程中，我们会如何收集、使用、共享、存储和保护您的个人信息，以及您可以如何管理您的个人信息，以便您更好地作出适当的选择。
        </p>
        <p>
          在您开始使用我们的产品和服务前，请您务必先仔细阅读和理解本政策，特别应重点阅读我们以<strong
            ><strong>粗体/粗体下划线</strong></strong
          >标识的条款，确保您充分理解和同意之后再开始使用。本政策中涉及的专业词汇，我们尽量以简明通俗的表述向您解释，以便于您理解。<strong
            ><strong
              >如对本政策内容有任何疑问、意见或建议，您可通过</strong
            ></strong
          ><strong><strong>潮韵拍卖</strong></strong
          ><strong><strong>提供的各种联系方式与我们联系。</strong></strong>
        </p>
        <p>&nbsp;</p>
        <p>
          <strong><strong>本政策将帮助您了解以下内容：</strong></strong>
        </p>
        <p>
          <strong><strong>一、定义及适用范围</strong></strong>
        </p>
        <p>
          <strong><strong>二、我们如何收集、使用您的信息</strong></strong>
        </p>
        <p>
          <strong><strong>三、我们如何使用Cookie和同类技术</strong></strong>
        </p>
        <p>
          <strong
            ><strong>四、我们如何共享、转让、公开披露您的信息</strong></strong
          >
        </p>
        <p>
          <strong><strong>五、我们如何保护您的信息</strong></strong>
        </p>
        <p>
          <strong><strong>六、我们如何存储您的信息</strong></strong>
        </p>
        <p>
          <strong><strong>七、您如何管理您的信息</strong></strong>
        </p>
        <p>
          <strong><strong>八、本政策如何更新</strong></strong>
        </p>
        <p>
          <strong><strong>九、您如何联系我们</strong></strong>
        </p>
        <p>&nbsp;</p>
        <p>
          <strong><strong>一、定义及适用范围</strong></strong>
        </p>
        <p>
          <strong><strong>（一）定义</strong></strong>
        </p>
        <p>
          <strong><strong>&nbsp; &nbsp; &nbsp;&nbsp;</strong></strong
          ><strong><strong>潮韵拍卖</strong></strong
          ><strong><strong>：</strong></strong
          >指潮韵拍卖（域名为:www.chaoauction.com）网站及潮韵拍卖客户端。
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;<strong><strong>个人信息</strong></strong
          >：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;<strong
            ><strong>个人敏感信息</strong></strong
          >：指包括身份证件号码、个人生物识别信息、银行账号、财产信息、交易信息等个人信息。
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;<strong
            ><strong>个人信息删除</strong></strong
          >：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。
        </p>
        <p>
          <strong><strong>（二）适用范围</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;本政策适用于潮韵拍卖服务提供者以网站、小程序以及随技术发展出现的新形态向您提供的各项产品和服务。
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;除本政策说明的相关信息收集使用活动外，本政策不适用于其他第三方向您提供的其他服务，其他服务适用其向您另行说明的隐私权政策等个人信息收集使用规则。
        </p>
        <p>&nbsp;</p>
        <p>
          <strong
            ><strong
              >二、我们如何收集、使用您的信息以及您可以如何管理您的信息</strong
            ></strong
          >
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;在您使用我们的产品/服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;1、为实现向您提供我们产品及/或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务；
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;2、为实现向您提供我们产品及/或服务的附加功能，您可选择是否授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果。
        </p>
        <p>我们在此特别提醒您：</p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;<strong
            ><strong
              >为给您带来更好的产品和服务体验，我们持续努力改进我们的产品、服务及技术，随之我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。如发生上述情形，我们将通过更新本政策、弹窗、页面提示等方式另行向您详细说明，并为您提供自主选择同意的方式，且在征得您明示同意后再开始收集、使用。</strong
            ></strong
          >在此过程中，如果您有任何疑问、意见或建议的，您可通过本政策文末联系方式与我们联系，我们会尽快为您作出解答。
        </p>
        <p>&nbsp; &nbsp; &nbsp;&nbsp;我们会为您提供的各项具体功能场景包括：</p>
        <ul>
          <li>
            <strong><strong>注册</strong></strong
            ><strong><strong>及账号管理</strong></strong>
          </li>
        </ul>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;我们提供了两种登录方式，手机验证码登录和微信授权登录。
        </p>
        <p>手机验证码登录需要您向我们提供手机号并填写验证码。</p>
        <p>微信授权登录需要您同意授权您微信的对应信息。</p>
        <p>
          如果您拒绝提供上述信息，您将无法注册潮韵拍卖平台账户，仅可以使用浏览、搜索等服务。
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;在您首次缴纳拍品保证金前，您需要根据国家法律法规和平台协议规则，要求您先提供实名信息进行认证，<strong
            ><strong>这些信息包括您本人身份证</strong></strong
          ><strong><strong>号码</strong></strong
          ><strong><strong>、姓名。</strong></strong
          >若实名失败我们不会进行存储。
        </p>
        <p>
          您也可以使用第三方帐号登录并使用，您将授权我们获取您在第三方平台注册的公开信息（头像、昵称以及您授权的其他信息），用于潮韵拍卖帐号绑定，使您可以直接登录并使用本产品和相关服务，我们将在您授权同意的范围内使用您的相关信息。此外，我们可能经您同意后向第三方共享您的帐号信息（头像、昵称及其他页面提示的信息），便于您方便实现第三方帐号的注册或第三方帐号的登录。
        </p>
        <p>
          <strong><strong>（二）展示拍品信息</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;向您展示的拍品信息，和您的个人信息没有任何关系，都来自于全体业务团队征集、整理、拍摄、编写等的工作结果。
        </p>
        <p>
          <strong><strong>（三）收藏功能</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;在您浏览我们网站或客户端小程序的过程中，您可以在拍品详情中对感兴趣的拍品进行收藏，您的收藏信息会记录在服务日志中用于实现收藏功能。
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;您可以在我的收藏中查看您的所有收藏信息。
        </p>
        <p>&nbsp; &nbsp; &nbsp;&nbsp;您可以在拍品详情中取消收藏。</p>
        <p>
          <strong><strong>（四）分享功能</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;为了您能够使用分享到微信的功能，我们使用了第三方微信分享SDK，会获取设备终端信息、网络信息、IP信息、设备型号；
        </p>
        <p>
          微信分享SDK更多隐私政策请参看：<a
            href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8"
            >https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</a
          >
        </p>
        <p>
          <strong><strong>（五）缴纳保证金</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;当您要参与拍品竞拍，需要缴纳相应的保证金。<strong
            ><strong>我们为您提供了微信支付。</strong></strong
          >
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;微信支付是集成了微信支付的SDK，微信的《微信隐私保护指引》：https://weixin.qq.com/cgi-bin/readtemplate?t=weixin_agreement&amp;s=privacy&amp;cc=CN、《微信支付用户服务协议》：https://weixin.qq.com/cgi-bin/readtemplate?t=weixin_business_pay
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;我们会收集您支付保证金的具体交易单号、交易时间、您支付的金额信息。我们收集这些信息是为了确认您的竞拍资格，并且在您未竞拍成功的24小时（分为全场保证金和单品保证金，不一定为24小时）后，自动将保证金原路退还。
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;您可以在&ldquo;保证金管理&rdquo;中查询保证金信息。
        </p>
        <p>
          <strong><strong>（六）出价竞拍</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;当您对某件拍品有竞拍资格后，您可以出比当前价格更高的价格，直到该拍品拍卖结束。
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;我们会记录您的出价金额、出价时间，用于和其他出价用户比较出出价领先的用户。
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;您可以在具体的拍品详情、我的参拍中查看当前的出价。
        </p>
        <p>
          <strong><strong>（七）完成下单及订单管理</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;当您成功拍下了某件拍品，我们会通过系统为您生成该拍品对应的订单。
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;该订单中会载明您所拍下的拍品信息、具体订单号、订单创建时间、您应支付的佣金金额、您应支付的保险金额、您应支付的落槌价金额等。我们收集这些信息是为了帮助您顺利完成交易、保障您的交易安全、便于您查询订单信息及其他我们明确告知的目的。
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;为便于您了解、查询订单信息并对订单信息进行管理，我们会收集您在使用我们服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。&nbsp;
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;您可以通过&ldquo;我的订单&rdquo;查看和管理您的订单信息。
        </p>
        <p>
          <strong><strong>（八）完成订单支付</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;我们为您提供了两种订单支付方式，一种是线上电子支付，一种是线下转账支付。
        </p>
        <p>
          线上电子支付，<strong
            ><strong>我们为您提供了微信支付、钱包支付</strong></strong
          ><strong><strong>。</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;微信支付是集成了微信支付的SDK，微信的《微信隐私保护指引》：https://weixin.qq.com/cgi-bin/readtemplate?t=weixin_agreement&amp;s=privacy&amp;cc=CN、《微信支付用户服务协议》：https://weixin.qq.com/cgi-bin/readtemplate?t=weixin_business_pay
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;线下转账支付，我们为您提供了我们的收款对公账户、银行、账号信息，您可以通过手机银行、银行柜台、ATM机、网银等方式进行转账。
        </p>
        <p>
          <strong><strong>（九）上门提货</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;当您可以自提拍品时，在下单过程中，需要提供<strong
            ><strong>提货人</strong></strong
          ><strong><strong>的姓名和身份证号码信息</strong></strong
          >，用于自提拍品时，工作人员核验提货人的身份，保障您的订单安全。
        </p>
        <p>
          <strong><strong>（十）物流配送</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;若您不方便上门提货，在下单过程汇总，您需要提供<strong
            ><strong>收货人姓名、收货地址、收货人联系电话</strong></strong
          >，用于我们联系物流公司，帮您安排配送。
        </p>
        <p>
          <strong><strong>（十一）客服及争议处理</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存您与我们的沟通、通信/通话记录及相关内容（包括账户信息、订单信息、您为了证明相关事实提供的其他信息，或您留下的联系方式信息），如果您针对具体订单进行咨询、投诉或提供建议的，我们会使用您的账户信息和订单信息。
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;为了提供服务及改进服务质量的合理需要，我们还可能使用您的其他信息，包括您与客服联系时提供的相关信息。
        </p>
        <p>
          <strong><strong>（十二）其他附加服务</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;为了提升您的体验，我们在向您提供的以下附加服务中可能会收集和使用您的个人信息。<strong
            ><strong>如果您不提供这些信息，不会影响您使用</strong></strong
          ><strong><strong>潮韵拍卖</strong></strong
          ><strong><strong>的基本服务，</strong></strong
          >但您可能无法获得这些附加服务给您带来的用户体验。这些附加服务包括：
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;<strong
            ><strong>1、基于位置信息的服务：</strong></strong
          >我们会在您开启位置权限后访问获取您的位置信息，根据您的位置信息为您提供到我们公司办公地点的导航服务。<strong
            ><strong
              >请你知晓，即使您已同意开启位置信息权限，我们也仅会在您主动点击地图等按钮时获取信息。</strong
            ></strong
          >
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;2<strong
            ><strong
              >、基于相册（图片库/视频库）的图片/视频访问及上传的服务</strong
            ></strong
          >：您可在开启相册权限后使用该功能上传您的照片/图片，以实现更换头像等功能。<strong
            ><strong
              >请您知晓，即使您已同意开启相册权限，我们也仅会在您主动拍摄、录制</strong
            ></strong
          ><strong><strong>、上传照片</strong></strong
          ><strong><strong>等使用相机/摄像头时获取信息。</strong></strong>
        </p>
        <p>
          <strong><strong>&nbsp; &nbsp; &nbsp;&nbsp;</strong></strong
          ><strong><strong>3</strong></strong
          ><strong><strong>、基于</strong></strong
          ><strong><strong>拨打电话的服务</strong></strong
          >：您可在开启拨打电话权限后与客服电话联系。<strong
            ><strong>请您知晓，即使您已同意</strong></strong
          ><strong
            ><strong
              >拨打电话权限，我们也仅会在您主动点击客户端内联系客服</strong
            ></strong
          ><strong><strong>按钮时调用权限。</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;4<strong
            ><strong>、基于存储权限的服务</strong></strong
          >：我们向您申请获取此权限，目的是为了保障客户端的稳定运行。在您开启我们可读取/写入您设备存储的权限后，我们将自您设备存储空间内读取或向其中写入图片、文件、崩溃日志信息等必要信息，用于向您提供信息发布或在本地记录崩溃日志信息等功能。
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;您理解并同意，上述附加服务可能需要您在您的设备中开启您的位置信息
          、相册（图片库）、或电话状态的访问权限，以实现这些权限所涉及信息的收集和使用。您可在您的设备设置或我们客户端&ldquo;我的-设置-隐私&mdash;系统权限管理&rdquo;中逐项查看上述权限的状态，并可自行决定这些权限随时的开启或关闭。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。以上信息获取是基于您开启了微信授权之后才会获取，如您不开启，我们不会收集以上信息。
        </p>
        <p>&nbsp;</p>
        <p>
          <strong><strong>（十三）收集和使用个人信息的其他规则</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;<strong
            ><strong
              >1、若您提供的信息中含有其他用户的个人信息，在向</strong
            ></strong
          ><strong><strong>潮韵拍卖</strong></strong
          ><strong
            ><strong
              >提供这些个人信息之前，您需确保您已经取得合法的授权。</strong
            ></strong
          >
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;<strong
            ><strong
              >2、若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，均会事先获得您的同意。</strong
            ></strong
          >
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;3、若我们从第三方处间接获取您的信息，我们会在收集前明确以书面形式要求该第三方说明其个人信息来源，以及是否已经就其收集、处理以及向我们提供您的个人信息取得了您的合法授权。除法律明确允许的情形外，我们只会在确认第三方已经取得您的授权同意后再从第三方收集您的个人信息，如果第三方的授权范围无法涵盖我们的处理和使用目的时，我们会自行或者要求该第三方征得您的同意后再行处理您的个人信息。
        </p>
        <p>&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;4、征得授权同意的例外</p>
        <p>
          根据相关法律法规规定，我们在以下情况下收集、使用您的个人信息无需您的授权同意：
        </p>
        <p>（1）与我们履行法律、法规规定的义务相关的；</p>
        <p>（2）与国家安全、国防安全直接相关的；</p>
        <p>（3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p>（4）与犯罪侦查、起诉、审判和判决执行等司法或行政执法直接相关的；</p>
        <p>
          （5）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
        </p>
        <p>（6）您自行向社会公众公开的个人信息；</p>
        <p>
          （7）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
        </p>
        <p>（8）根据与您签订和履行相关协议或其他书面文件所必需的；</p>
        <p>
          （9）用于维护所提供的产品及/或服务的安全稳定运行所必需的，例如发现、处置产品及/或服务的故障；
        </p>
        <p>（10）法律法规规定的其他情形。</p>
        <p>
          5、如我们停止运营潮韵拍卖产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对我们所持有的与已关停业务相关的个人信息进行删除或匿名化处理。
        </p>
        <p>&nbsp;</p>
        <p>
          <strong><strong>三、我们如何使用Cookie和同类技术</strong></strong>
        </p>
        <p>
          <strong><strong>（一）Cookie的使用</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;为确保网站正常运转、为您获得更轻松的访问体验，我们会在您的计算机或移动设备上存储Cookie、Flash
          Cookie，或浏览器（或关联应用程序）提供的其他通常包含标识符、站点名称以及一些号码和字符的本地存储（统称&ldquo;Cookie&rdquo;）。借助于
          Cookie，网站能够存储您的竞拍信息、订单信息等数据。
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;<strong
            ><strong
              >如果您的浏览器或浏览器附加服务允许，您可修改对Cookie的接受程度或拒绝我们的Cookie</strong
            ></strong
          >。有关详情，请参见
          AboutCookies.org。但如果您执行本条所述操作，在某些情况下可能会影响您安全访问我们的网站，且可能需要在您每一次访问我们的网站时更改用户设置。
        </p>
        <p>
          <strong><strong>（二）SDK的使用</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;为保障我们客户端的稳定运行、功能实现，使您能够享受和使用更多且优质的服务及功能，我们的应用中会嵌入授权合作伙伴的SDK或其他类似的应用程序。我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。
        </p>
        <p>以下是我们接入授权合作伙伴的SDK详细清单：</p>
        <p>
          <strong><strong>腾讯</strong></strong>
        </p>
        <p>功能：用于帮助用户将信息分享至微信、可帮助用户完成付款、检测异常</p>
        <p>收集个人信息类型：设备标识符（IMEI、IMSI、制造商、系统版本）</p>
        <p>隐私权政策链接：https://www.qq.com/yszc.htm</p>
        <p>
          <strong><strong>极光推送</strong></strong>
        </p>
        <p>功能：统计、推送通知</p>
        <p>
          收集个人信息类型：设备MAC地址、应用安装列表、设备标识符（IMEI、IMSI、制造商、系统版本）、位置信息
        </p>
        <p>隐私权政策链接：https://www.jiguang.cn/license/privacy</p>
        <p>
          <strong
            ><strong>四、我们如何共享、转让、公开披露您的信息</strong></strong
          >
        </p>
        <p>
          <strong><strong>（一）共享</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;我们不会与潮韵拍卖服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;1、在法定情形下的共享：我们可能会根据法律法规规定、诉讼、争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;2、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;3、为您提供您需要的产品或服务必要的情况下共享：您通过潮韵拍卖平台购买商品或服务，我们会根据您的选择，将您的订单信息中与交易有关的必要信息共享给相关商品或服务的提供者，以实现您的交易、配送及售后服务需求。
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;4、与授权合作伙伴共享：<strong
            ><strong
              >我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能</strong
            ></strong
          >，我们仅会出于本政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到其履行职责所需信息，且我们将会通过协议要求其不得将此信息用于其他任何目的。
        </p>
        <p>目前，我们的授权合作伙伴包括以下类型：</p>
        <p>
          （1）广告、分析服务类的授权合作伙伴。我们会委托这些合作伙伴处理与广告覆盖面和有效性相关的信息，但除非得到您的许可，否则我们不会将您的个人身份信息与提供广告、分析服务的合作伙伴共享，或者我们会将这些信息进行去标识化处理，以便授权合作伙伴无法识别您个人。这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的广告服务或决策建议。
        </p>
        <p>
          （2）供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括受我们委托提供的技术基础设施服务、分析我们服务的使用方式、提供客户服务、支付便利或进行学术研究和调查。
        </p>
        <p>
          <strong><strong>（二）转让</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp;
          &nbsp;&nbsp;我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
        </p>
        <p>
          1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
        </p>
        <p>
          2、在潮韵拍卖服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
        </p>
        <p>
          <strong><strong>（三）公开披露</strong></strong>
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;我们仅会在以下情况下，公开披露您的个人信息：
        </p>
        <p>
          1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；
        </p>
        <p>
          2、<strong
            ><strong>如果我们确定您出现违反法律法规或严重违反</strong></strong
          ><strong><strong>潮韵拍卖</strong></strong
          ><strong><strong>平台相关协议及规则的情况，或为保护</strong></strong
          ><strong><strong>潮韵拍卖</strong></strong
          ><strong
            ><strong
              >平台用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或征得您同意的情况下披露关于您的个人信息</strong
            ></strong
          >，包括相关违规行为以及潮韵拍卖平台已对您采取的措施。
        </p>
        <p>&nbsp;</p>
        <p>
          <strong
            ><strong
              >（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</strong
            ></strong
          >
        </p>
        <p>
          根据相关法律法规规定，以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
        </p>
        <p>1、与我们履行法律法规规定的义务相关的；</p>
        <p>2、与国家安全、国防安全直接相关的；</p>
        <p>3、与公共安全、公共卫生、重大公共利益直接想关的；</p>
        <p>4、与犯罪侦查、起诉、审判和判决执行等司法或行政执法直接相关的；</p>
        <p>
          5、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
        </p>
        <p>6、您自行向社会公众公开的个人信息；</p>
        <p>
          7、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;&nbsp;请知悉，根据适用的法律，<strong
            ><strong
              >若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。</strong
            ></strong
          >
        </p>
        <p>&nbsp;</p>
        <p>
          <strong><strong>五、我们如何保护您的信息</strong></strong>
        </p>
        <p>
          <strong><strong>（一）我们采取的数据保护技术措施</strong></strong>
        </p>
        <p>
          我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。
        </p>
        <p>
          例如，我们会使用加密技术提高个人信息的安全性，在您的浏览器与服务器之间交换数据时受&nbsp;SSL协议加密保护；我们在服务器端购买防火墙服务防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息。
        </p>
        <p>
          <strong><strong>（二）我们采取的数据保护管理组织措施</strong></strong>
        </p>
        <p>
          我们建立了以数据为核心、围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升个人信息的安全性。
        </p>
        <p>
          我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
        </p>
        <p>
          <strong><strong>（三）个人信息安全事件的响应</strong></strong>
        </p>
        <p>
          如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损的，我们会及时启动应急预案，采取合理救济措施，以尽可能降低对您个人信息和其他权益的影响。如发生个人信息安全事件，我们还将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
        </p>
        <p>&nbsp;</p>
        <p>
          <strong><strong>（四）账户安全风险的自主防范</strong></strong>
        </p>
        <p>
          我们强烈建议您在使用潮韵拍卖平台服务时不要使用非潮韵拍卖平台推荐的通信方式发送您的信息，同时请您使用复杂密码，协助我们保护您的账户安全。
        </p>
        <p>&nbsp;</p>
        <p>
          <strong><strong>六、我们如何存储您的信息</strong></strong>
        </p>
        <p>
          <strong><strong>（一）存储地点</strong></strong>
        </p>
        <p>
          我们在中华人民共和国境内运营中收集和产生的个人信息，将存储在中国境内。
        </p>
        <p>
          <strong
            ><strong
              >目前我们的业务内容中，不会向境外实体提供您的个人信息，不存在您的个人信息出境的情况。</strong
            ></strong
          >
        </p>
        <p>&nbsp;</p>
        <p>
          <strong><strong>（二）存储期限</strong></strong>
        </p>
        <p>
          <strong
            ><strong
              >我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求。</strong
            ></strong
          >我们判断个人信息的存储期限主要参考以下标准并以其中较长者为准：
        </p>
        <p>
          1、完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；
        </p>
        <p>2、保证我们为您提供服务的安全和质量；</p>
        <p>3、您是否同意更长的留存期间；</p>
        <p>4、是否存在关于保留期限的其他特别约定或法律法规规定。</p>
        <p>
          在超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。
        </p>
        <p>&nbsp;</p>
        <p>
          <strong><strong>七、您如何管理您的信息</strong></strong>
        </p>
        <p>
          您除了可以按照本政策第二节中的操作路径在我们的客户端上自行操作以外，您还可以通过以下方式访问及管理您的信息：
        </p>
        <p>
          <strong><strong>（一）查询、更正和补充您的信息</strong></strong>
        </p>
        <p>您有权查询、更正或补充您的信息。您可以通过以下方式自行进行：</p>
        <p>登录潮韵拍卖小程序，点击设置，可以查询、更正个人资料信息；</p>
        <p>&nbsp;</p>
        <p>
          <strong><strong>（二）删除您的信息</strong></strong>
        </p>
        <p>
          我们不建议您主动操作删除，删除信息有可能会导致您的其他信息出现问题。
        </p>
        <p>
          建议您在以下情形中，您可以通过与潮韵拍卖客服向我们提出删除个人信息的请求：
        </p>
        <p>1、如果我们处理个人信息的行为违反法律法规；</p>
        <p>2、如果我们收集、使用您的个人信息，却未征得您的明确同意；</p>
        <p>3、如果我们处理个人信息的行为严重违反了与您的约定；</p>
        <p>
          若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，并要求其及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）。
        </p>
        <p>
          <strong
            ><strong
              >当您或我们协助您删除相关信息后，因为适用的法律和安全技术限制，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并限制对其的任何进一步的处理，直到备份可以清除或实现匿名化。</strong
            ></strong
          >
        </p>
        <p><span style="text-decoration: line-through;">&nbsp;</span></p>
        <p>
          <strong><strong>（</strong></strong
          ><strong><strong>三</strong></strong
          ><strong><strong>）响应您的上述请求</strong></strong>
        </p>
        <p>
          <strong
            ><strong
              >为保障您的账户安全，您向我们提出上述请求时，我们可能会先要求您验证您的身份（如要求您提供书面请求或其他方式），然后再处理您的请求。</strong
            ></strong
          >
        </p>
        <p>对于您向我们提出的上述请求，我们将在15日内做出答复。</p>
        <p>
          <strong
            ><strong
              >对于与您的身份不直接关联的信息、无合理理由重复申请的信息，或者需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。</strong
            ></strong
          >
        </p>
        <p>
          <strong
            ><strong
              >在以下情形中，按照法律法规要求，我们将无法响应您的请求：</strong
            ></strong
          >
        </p>
        <p>
          <strong
            ><strong>1、与我们履行法律法规规定的义务相关的；</strong></strong
          >
        </p>
        <p>
          <strong><strong>2、与国家安全、国防安全直接相关的；</strong></strong>
        </p>
        <p>
          <strong
            ><strong
              >3、与公共安全、公共卫生、重大公共利益直接相关的；</strong
            ></strong
          >
        </p>
        <p>
          <strong
            ><strong
              >4、与刑事犯罪侦查、起诉、审判和执行判决等直接相关的；</strong
            ></strong
          >
        </p>
        <p>
          <strong
            ><strong
              >5、有充分证据表明个人信息主体存在主观恶意或滥用权利的；</strong
            ></strong
          >
        </p>
        <p>
          <strong
            ><strong
              >6、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</strong
            ></strong
          >
        </p>
        <p>
          <strong
            ><strong
              >7、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</strong
            ></strong
          >
        </p>
        <p>
          <strong><strong>8、涉及商业秘密的。</strong></strong>
        </p>
        <p>&nbsp;</p>
        <p>
          <strong><strong>八、本政策如何更新</strong></strong>
        </p>
        <p>
          我们的服务以及技术不断跟随您以及其他的用户的需求更新和优化，因此在新的服务及业务流程变更时，我们可能会更新我们的隐私权政策以告知您具体的变化。但未经您明确同意，我们不会限制您按照本政策所应享有的权利。我们会在专门页面上发布对本政策所做的任何变更。
        </p>
        <p>
          <strong
            ><strong>对于重大变更，我们还会提供更为显著的通知（</strong></strong
          ><strong><strong>潮韵拍卖</strong></strong
          ><strong><strong>小程序</strong></strong
          ><strong><strong>首页轮播图、</strong></strong
          ><strong><strong>潮韵拍卖</strong></strong
          ><strong><strong>小程序公告</strong></strong
          ><strong><strong>页等公示的方式通知您）。</strong></strong>
        </p>
        <p>本政策所指的重大变更包括但不限于：</p>
        <p>
          1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
        </p>
        <p>
          2、我们在控制权等方面发生重大变化。如并购重组等引起的信息控制者变更等；
        </p>
        <p>3、个人信息共享、转让或公开披露的主要对象发生变化；</p>
        <p>4、您拥有的个人信息处理方面的权利及其行使方式发生重大变化；</p>
        <p>
          5、我们负责处理个人信息保护的责任部门、联络方式及投诉渠道发生变化。
        </p>
        <p>&nbsp;</p>
        <p>
          <strong><strong>九、您如何联系我们</strong></strong>
        </p>
        <p>
          如您对本政策有任何疑问、意见或建议，或者您在管理您的个人信息时遇到任何问题，您可通过我们提供的多种反馈渠道与我们联系：
        </p>
        <p>
          1、您的个人信息相关咨询、投诉问题，可通过潮韵拍卖客服与我们取得联系，联系电话18058734691。
        </p>
        <p>
          2、如您对本政策内容有任何疑问、意见或建议，可与我们的个人信息保护负责人联系，联系方式：18058734691。
        </p>
        <p>&nbsp;</p>
      </template>
      <template v-else-if="type == 12">
        <p style="text-align: center;">潮韵拍卖拍卖规则</p>
        <p>
          拍卖规则适用于拍卖人浙江潮韵拍卖有限公司通过网络平台（www.chaoauction.com）及潮韵拍卖小程序客户端，以下简称&ldquo;潮韵拍卖&rdquo;）进行之网络拍卖行为。本规则根据《中华人民共和国拍卖法》及其他有关法律、法规并参照国际通行惯例制定，竞买人、买受人和委托人均须仔细阅读，并对自己参与网络拍卖之行为负责，如因未仔细阅读本规则而引发的任何损失或责任均由行为人自行承担。因网络故障或其他原因，拍卖人有权自行决定将拍卖延期或取消，无需向委托人、竞买人作出任何赔偿。本规定以外的特殊问题及未尽事项，由拍卖人依据本规则之原则予以解释和处理。对有争议之法律问题，适用中华人民共和国法律解决。
        </p>
        <p>&nbsp;第一部分　关于竞买人与买受人的主要条款</p>
        <p>一、竞买人及买受人</p>
        <p>
          （一）竞买人是指在浙江潮韵拍卖有限公司提供的网络平台（www.chaoauction.com）及潮韵拍卖小程序客户端（以下简称潮韵拍卖）注册登记参加竞购拍卖标的的公民、法人或者其他组织。
        </p>
        <p>（二）买受人是指在潮韵拍卖以最高应价购得拍卖标的的竞买人。</p>
        <p>
          （三）竞买人应妥善保管其在潮韵拍卖的会员账号，他人登录竞买人会员账号参与竞买的后果由竞买人承担法律责任。
        </p>
        <p>
          （四）潮韵拍卖实行会员制，任何人只有在签署（包括但不限于书面签署、通过潮韵拍卖线上签署等方式）具有法律约束力的文件后，方可注册成为潮韵拍卖的会员，办理潮韵拍卖规定的手续并缴纳保证金后，该会员才有权利参与竞买。未经注册，只可在一定范围内浏览作品或享受潮韵拍卖的其它服务，但无资格参与竞买。
        </p>
        <p>
          （五）竞买人应向拍卖人指定的账户支付保证金。保证金按有关规定的数额交纳，但拍卖人与竞买人另有约定的除外。对指定拍品及专场，竞买人必须通过实名认证、并缴纳规定数额的保证金才可竞买。拍卖结束后，若竞买人未能购得拍卖标的且对拍卖人无任何欠款，则该保证金在拍卖结束后十二个工作日内按原保证金支付渠道全额无息返还至竞买人，但遇网络运营技术调整或网络故障的，则不在此时限内。若竞买人成为买受人的，则应在拍卖成交后的七日内支付拍卖价款（保证金予以抵扣），七日内仍未付清购买价款者，即视为违约，拍卖人有权没收买受人在拍卖人处的所有拍卖保证金并追究该违约者的一切责任。
        </p>
        <p>
          （六）潮韵拍卖的&ldquo;钱包&rdquo;功能用于竞买人对本人会员账号下的&ldquo;钱包&rdquo;进行充值，支付保证金和拍品价款。
        </p>
        <p>
          （七）竞买人注册成为潮韵拍卖会员，即表示遵守和认可本拍卖规则和拍卖人及潮韵拍卖的其他规定。
        </p>
        <p>
          （八）竞买人在潮韵拍卖的出价表示认可该加价幅度，最终出价结果以拍卖人确认为准。
        </p>
        <p>
          （九）竞买人应对自己在任何价位的应价行为负责，收到拍卖人及潮韵拍卖发出的系统消息、短信等通知或以其他公开表示买定的方式确认后拍卖即成交。最高出价人不得反悔并应按照成交确认书（其形式包括但不限于拍卖人及潮韵拍卖发出的系统消息、短信，及传真、电话、信函、电子即时通信等有效的通知方式）提示的价格支付价款，否则须承担法律责任。
        </p>
        <p>
          （十）如因网络、通讯信号、系统故障、病毒入侵、黑客攻击、录入信息错误等原因导致的竞买人或买受人无法使用网络平台、网络延迟、网络账户的用户名和密码被盗、未能竞买成功或其他交易异常情况所产生的损失不承担任何法律责任；对因上述原因导致拍卖结果错误的，拍卖人有权取消成交结果，无需向委托人、竞买人或买受人承担任何责任。因竞买人或买受人操作差错所造成的损失由竞买人、买受人本人承担。
        </p>
        <p>
          拍卖人及潮韵拍卖并不保证网络平台或与其有关的服务、内容、功能或材料将实时更新，亦不保证网络平台的安全、稳定、不受干扰或无误，或有关缺陷已修正。拍卖人及潮韵拍卖对因上述情况导致的竞买人或买受人未能竞买成功或产生的其他损失不承担任何法律责任。
        </p>
        <p>
          对于竞买人或买受人进入、使用网络平台后发生的电脑设备或其他财产损坏或感染病毒、被黑客攻击，拍卖人及潮韵拍卖不承担任何法律责任。
        </p>
        <p>
          进入潮韵拍卖平台后，竞买人或买受人链接到第三方网站，拍卖人及潮韵拍卖不就第三方网站提供的或通过该网站提供的内容承担责任。竞买人或买受人须自行承担链接任何第三方网站的风险，并承担因该链接所导致的一切责任和后果。
        </p>
        <p>
          因竞买人或买受人用户名、银行卡账号或密码等泄露致使他人冒名竞买造成的任何损失，由竞买人或买受人自行承担。
        </p>
        <p>若竞买人或买受人对网络平台有任何异议或疑义，请停止使用网络平台。</p>
        <p>&nbsp;</p>
        <p>&nbsp;&nbsp;二、对拍品描述的说明</p>
        <p>
          （一）拍卖人及潮韵拍卖对拍卖标的的说明仅作为拍卖预告并仅供竞买人参考，竞买人在作出竞买行为前应当自行核实拍卖标的的情况，本拍卖规则对参与拍卖的当事人均具有约束力。
        </p>
        <p>
          （二）拍卖人及潮韵拍卖对拍卖标的有关作者、来历、日期、年代、尺寸、质材、装裱、归属、真实性、出处、保存情况、估价或艺术价值所作的介绍，不表明拍卖人及潮韵拍卖所作的担保，仅作为意见供竞买人参考，不构成对拍卖标的的任何担保或承诺。
        </p>
        <p>
          （三）因摄影、显示器等因素造成拍卖人在潮韵拍卖登录的作品色调、层次等与原物有误差的，应以原物为准。
        </p>
        <p>
          （四）拍卖人及潮韵拍卖如未对拍卖标的提供有关资料，并非表明某拍卖标的无瑕疵；已指出的某些特定瑕疵，也并非表明其再无其他瑕疵。
        </p>
        <p>
          （五）拍卖人及潮韵拍卖对拍卖标的的真伪及品质不承担瑕疵担保责任。竞买人应在拍卖日前，以鉴定或其他方式（包括聘请专家）查验拟竞买拍卖标的之原物，自行判断该拍卖标的的真伪及品质。一旦参与竞买，即视为已行使上述权力并认可该拍卖标的之现状（包括瑕疵），对竞买该拍卖标的的行为承担法律责任，并不得以任何理由拒付拍卖款及佣金和其他费用，否则拍卖人将按本规则对其追究违约责任。
        </p>
        <p>&nbsp;三、佣金</p>
        <p>
          &emsp;&emsp;买受人竞得拍卖标的后，应向拍卖人支付拍卖&ldquo;成交价&rdquo;10%
          的佣金。如不支付该佣金的，拍卖人除有权要求买受人承担违约责任外，还有权拒绝买受人领取拍卖标的。
        </p>
        <p>&nbsp;四、付款及领取拍卖标的</p>
        <p>
          （一）拍卖成交后，买受人最迟应在拍卖成交后的五日内付清拍卖价款，原付之保证金予以抵扣。
        </p>
        <p>
          （二）买受人支付拍卖价款的币种为人民币，异类货币按付款当日买受人所选支付渠道确定的汇率进行结算。
        </p>
        <p>
          （三）买受人全额支付拍卖标的价款及佣金后，方可获得拍卖标的之所有权；买受人尚未全额付清拍卖价款及佣金前，不得领取在拍卖人处的所有拍卖标的。
        </p>
        <p>
          （四）如买受人选择自行前往拍卖人处提货，需在工作日进行提货。因买受人原因，未在拍卖成交后七个工作日内领取其拍卖成交的标的的。该拍卖标的的搬运、仓储等费用、风险由买受人承担，拍卖人及潮韵拍卖不承担责任。
        </p>
        <p>
          （五）买受人需支付拍品成交价的1%作为保险费（发往国际及港澳台的，买受人应按国家对拍卖标的出境的相关规定，办理手续，并支付相应物流费用，运输风险自负）。一经发出至买受人在结算时指定的地址及收货人，物流公司之系统显示签收后，即视为签收。如收货人委托他人代为签收，需按物流公司指示完成委托手续，否则因此造成的损失由买受人承担。因买受人原因未能即时签收的，该拍卖标的的搬运、仓储等费用、后果由买受人承担，拍卖人及潮韵拍卖概不承担。拍卖人及潮韵拍卖向买受人推荐的包装及运输方式仅应视为拍卖人及潮韵拍卖对买受人提供的服务，买受人一经同意即视为自愿委托，因包装或运输所造成的一切过失与拍卖人及潮韵拍卖无关。如运输途中发生拍卖标的遗漏、损坏或灭失，则根据中国有关法律、法规处理，在相关保险公司支付了赔偿款的情况下，拍卖人及潮韵拍卖在扣除应支付的费用（佣金除外）后，将余款交付给买受人。
        </p>
        <p>
          （六）因酒类拍品性质特殊，运输过程中导致的轻微渗漏属正常现象。&nbsp;
        </p>
        <p>&nbsp;五、拍卖标的出售后之责任</p>
        <p>
          &emsp;&emsp;拍卖成交后，买受人即对已成交的拍卖标的负全部责任，即使该拍卖标的仍由拍卖人或代理人保管的，保管期间非因拍卖人故意行为而致拍卖标的损失、损坏的，风险仍由买受人承担。&nbsp;
        </p>
        <p>&nbsp;六、逾期付款或未及时领取拍卖标的的处理</p>
        <p>
          &emsp;&emsp;拍卖成交后，买受人不付款、未付清拍卖款、不按规定时间领取拍卖标的行为属违约行为，拍卖人及潮韵拍卖有权单方面解除合同，并无须通知买受人而采取以下一项或多项措施：&nbsp;
        </p>
        <p>
          （一）向拍卖人住所地法院起诉，要求买受人支付拍卖款及佣金、利息、违约金和其他费用，并支付因违约给拍卖人及委托人造成的一切损失，包括但不限于律师在法院一、二、再审及执行程序的代理费（每个程序在诉讼标的或申请执行标的的7%以内）、诉讼保全担保费。
        </p>
        <p>
          （二）买受人在拍卖人处的所有竞买保证金拍卖人有权不予退还，同时拍卖人还有权要求买受人自应付款之日，按未付款部分（含佣金）的日万分之五向拍卖人支付利息，还有权要求买受人按未付款的30%向拍卖人支付违约金，且买受人不得以实际损失为由进行抗辩。
        </p>
        <p>
          如买受人已经支付了部分款项的，已经支付的款项应在扣除其因迟延支付拍卖款而发生的利息、保管费及拍卖人的其他损失后，剩余部分再作为拍卖款进行结算。
        </p>
        <p>
          在买受人未及时支付拍卖款时，潮韵拍卖可以直接扣划买受人在潮韵拍卖&ldquo;钱包&rdquo;中的账户余额，作为逾期利息、保管费、拍卖款及违约金和其他费用，余额不足部分买受人仍有义务支付。
        </p>
        <p>
          （三）有权按拍卖标的未付款的日万分之三向买受人收取保管费。买受人同时拍得多件拍卖标的的，而未按本规则规定时间支付任一拍卖标的价款的，拍卖人有权留置全部拍品。
        </p>
        <p>
          （四）取消其在潮韵拍卖的会员资格，并在公众传播媒体上公开点名谴责违约者及其违约行为。
        </p>
        <p>
          （五）再行拍卖或以其他方式出售该拍卖标的。拍卖人再行拍卖或出售拍卖标的的，原买受人应当支付前次拍卖中本人及委托人应当支付的佣金。再行拍卖的价款低于原拍卖价款的，原买受人应当补足差额。再行拍卖的价款高于原拍卖价款的，高出部分归拍卖人或委托人，但原买受人仍应承担违约责任。
        </p>
        <p>
          （六）拍卖成交后，如买受人未向拍卖人支付拍卖价款，委托人要求取回该拍卖标的的，拍卖人经审核同意后，拍卖人与买受人的拍卖合同解除，但拍卖人仍有权追究买受人的违约责任。
        </p>
        <p>七、担保声明</p>
        <p>
          &emsp;&emsp;根据拍卖法的相关规定，拍卖人、潮韵拍卖声明：任何人或代理人对任何拍卖标的用任何方式所作的内容介绍及评价（网站、幻灯投影、新闻载体等），仅属参考意见，并未表示任何担保，拍卖人及潮韵拍卖对拍卖标的的真伪或品质不承担担保责任，拍卖人对拍卖标的的说明仅供参考，竞买人应亲自至拍卖人及潮韵拍卖处查看拍卖标的原物，对自己竞买拍卖标的的行为承担法律责任。
        </p>
        <p>&nbsp;</p>
        <p>本拍卖规则及拍卖平台的下列词语的含义如下：</p>
        <p>一、&ldquo;拍卖人&rdquo;指浙江潮韵拍卖有限公司。</p>
        <p>
          二、&ldquo;潮韵拍卖&rdquo;指潮韵拍卖网络科技有限公司提供的平台www.chaoauction.com及潮韵拍卖网拍手机客户端。
        </p>
        <p>
          三、&ldquo;各项费用&rdquo;指拍卖人对拍卖标的价款、佣金、保管费等收取的费用。
        </p>
        <p>
          四、&ldquo;赝品&rdquo;指拍卖标的经刻意制造，其作者、来历、日期、年代、时期、文化或来源各方面资料均系伪造，与目录内之说明不相符。
        </p>
        <p>五、&ldquo;拍卖标的&rdquo;指在潮韵拍卖进行拍卖的物品或财产权利。</p>
        <p>
          六、&ldquo;估价&rdquo;指由拍卖人在潮韵拍卖上对每件拍卖标的明示的估计价格，该估价可进行调整。
        </p>
        <p>
          七、&ldquo;成交价&rdquo;指买受人通过潮韵拍卖系统成功竞得拍品的最高价格，成功与否以拍卖人最终确认为准。
        </p>
        <p>八、&ldquo;佣金&rdquo;指拍卖人按一定比例买受人收取的费用。</p>
        <p>十、&ldquo;拍卖款&rdquo;是指成交价加上佣金的拍卖价款。</p>
        <p>
          十一、&ldquo;拍卖收益&rdquo;指拍卖人在成交价的基础上扣除按一定比率计算的佣金、各项费用后的余额。
          &nbsp;&nbsp;
        </p>
        <p>
          十二、&ldquo;拍卖成交日&rdquo;指拍卖人在潮韵拍卖举办的网络拍卖活动中，以系统确认或者以其他公开表示买定的方式确认任何拍卖标的达成交易的日期。
        </p>
        <p>
          十三、&ldquo;印鉴&rdquo;指拍卖标的上原有的印章，且登录在潮韵拍卖的文字说明，但该说明文字仅供竞买人参考。
        </p>
        <p>十四、&ldquo;设色&rdquo;指该件拍卖标的（中国字画）系彩色。</p>
        <p>
          十五、&ldquo;管辖&rdquo;是指因履行合同发生争议的处理法院。竞买人、买受人与拍卖人因履行合同发生争议的，由拍卖人住所地人民法院管辖。
        </p>
        <p>
          十六、竞买人及买受人在拍卖人及潮韵拍卖登记的联系方式或身份信息，视为拍卖人与其联系的有效信息。拍卖人或潮韵拍卖按此联系信息向竞买人及买受人发出通知及其他文件，一经发出至即视为送达。如竞买人及买受人上述联系信息发生变更的，应书面通知拍卖人，否则视为未变更。
        </p>
        <p>*本《拍卖规则》由拍卖人负责解释。</p>
        <p>&nbsp;潮韵拍卖有限公司</p>
      </template>
      <!-- 华侨黄金个人-租赁协议 -->
      <template v-else-if="type == 13">
        <img
        src="@/assets/images/13.png"
      /></template>
      <!-- 华侨黄金企业-租赁协议 -->
      <template v-else-if="type == 14">
        <img
        src="@/assets/images/14.png"
      /></template>
      <!-- 华侨黄金个人-购买协议 -->
      <template v-else-if="type == 15">
        <img
        src="@/assets/images/15.png"
      /></template>
      <!-- 华侨黄金企业-购买协议 -->
      <template v-else-if="type == 16">
        <img
        src="@/assets/images/16.png"
      /></template>
      <!-- 寄售-销售协议 -->
      <template v-else-if="type == 17">
        <img
        src="@/assets/images/17.jpg"
      /></template>
      <!-- 寄售-寄售协议 -->
      <template v-else-if="type == 18">
        <img
        src="@/assets/images/18.jpg"
      /></template>
    </template>
    <template v-else>
      <img
        :src="dataSource.storageImagePath"
        v-if="type == 1"
        @load="loadImage"
      />
      <img
        :src="dataSource.buyImagePath"
        v-else-if="type == 2"
        @load="loadImage"
      />
    </template>
  </div>
</template>
<script>
import CCol from '@/components/grid/gCol';
import CRow from '@/components/grid/gRow';
export default {
  name: 'CProtocol',
  components: { CCol, CRow },
  props: {
    type: {
      type: [String, Number],
      default: 3,
    },
    readonly: {
      type: [String, Number],
      default: 1,
    },
    dataSource: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    loadImage() {
      this.$loading.stop();
    },
  },
};
</script>
<style>
body {
  margin: 0px;
  padding: 0px;
}
input[type='checkbox'],
input[type='radio'] {
  width: 20px;
  height: 20px;
}
.container {
  color: black;
  line-height: 1.8;
  word-wrap: break-word;
  word-break: break-all;
}
#xform {
  padding: 10px 0px;
}
.table-responsive {
  padding: 1px;
}
.table-sheet > .table > tbody > tr > td,
.table-sheet > .table > tbody > tr > th,
.table-sheet > .table > tfoot > tr > td,
.table-sheet > .table > tfoot > tr > th,
.table-sheet > .table > thead > tr > td,
.table-sheet > .table > thead > tr > th {
  white-space: nowrap;
}
.table-sheet-wrap > .table {
  table-layout: fixed;
}
.table-sheet-wrap > .table > tbody > tr > td,
.table-sheet > .table > tbody > tr > th,
.table-sheet > .table > tfoot > tr > td,
.table-sheet > .table > tfoot > tr > th,
.table-sheet > .table > thead > tr > td,
.table-sheet > .table > thead > tr > th {
  white-space: normal;
  word-break: break-word;
}
.form-control {
  display: inline;
  margin-top: 2px;
}
.img-responsive {
  display: block;
  margin: 10px auto;
}
.h1,
h1 {
  font-size: 24px;
}
.h2,
h2 {
  font-size: 20px;
}
.h3,
h3,
.h4,
h4 {
  font-size: 18px;
}
.h5,
h5,
.h6,
h6 {
  font-size: 14px;
}
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  line-height: 1.8;
  font-weight: bold;
}
.font-size-xx-small {
  font-size: 6px;
}
.font-size-x-small {
  font-size: 8px;
}
.font-size-small {
  font-size: 12px;
}
.font-size-normal {
  font-size: 0.28rem;
}
.font-size-medium {
  font-size: 16px;
}
.font-size-large {
  font-size: 18px;
}
.font-size-x-large {
  font-size: 24px;
}
.font-size-xx-large {
  font-size: 28px;
}
td > p {
  margin: 0px;
}
.dir-title {
  position: fixed;
  width: 100%;
  display: block;
  background: #f0f0f0;
  text-align: center;
  padding: 8px;
  font-weight: bold;
}
.dir-title-bottom {
  height: 40px;
}
.btn-dir {
  border: 1px solid #ddd;
  text-align: center;
  position: fixed;
  background: #fff8;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.12);
  color: #000;
  font-size: 14px;
  width: 40px;
  height: 40px;
  line-height: 38px;
  border-radius: 50%;
  bottom: 20px;
  right: 20px;
}
.btn-fs-add {
  border: 1px solid #ddd;
  text-align: center;
  position: fixed;
  background: #fff8;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.12);
  color: #808080;
  font-size: 18px;
  width: 40px;
  height: 40px;
  line-height: 38px;
  border-radius: 50%;
  bottom: 110px;
  right: 20px;
}
.btn-fs-minus {
  border: 1px solid #ddd;
  text-align: center;
  position: fixed;
  background: #fff8;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.12);
  color: #808080;
  font-size: 18px;
  width: 40px;
  height: 40px;
  line-height: 38px;
  border-radius: 50%;
  bottom: 65px;
  right: 20px;
}
.toc-item {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.toc-item:hover {
  background: #f0f0f0;
}
.toc-item-1 {
  padding: 8px 18px;
  font-weight: bold;
  color: #333333;
}
.toc-item-2 {
  padding: 8px 30px;
  color: #666;
}
.md-dir {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  height: calc(100vh);
  overflow: auto;
}
.sm-dir {
  display: none;
  width: 100%;
}
</style>
<style lang="scss" scoped>
@import 'var';
.protocol {
  padding: 0.2rem 0;
  h1 {
    font-size: 0.34rem;
    text-align: center;
    color: #333333;
    font-weight: 700;
    margin-bottom: 0.2rem;
  }
  h3 {
    font-size: 0.28rem;
    text-align: center;
    color: red;
    font-weight: 700;
  }
  p {
    text-indent: 2em;
    // text-align: justify;
    @include sc(0.28rem, $color);
  }
  .strong {
    font-weight: 700;
  }
  .reason {
    margin-right: 0.1rem;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
.markdown-body {
  text-align: left;
  font-size: 14px;
  line-height: 1.6;
  padding: 10px 0;
  overflow: auto;
  width: 100%;
  background-color: #fff;
}
.markdown-body > :last-child {
  margin-bottom: 0 !important;
}

.markdown-body > :first-child {
  margin-top: 0 !important;
}
.markdown-body table {
  border-collapse: collapse;
  border-spacing: 0;
  display: block;
  width: 100%;
  overflow: auto;
}
.markdown-body table tr {
  background-color: #fff;
  border-top: 1px solid #ccc;
}
.markdown-body table td,
.markdown-body table th {
  padding: 6px 13px;
  border: 1px solid #ddd;
}
.markdown-body td,
.markdown-body th,
.markdown-body ul {
  padding: 0;
}
html,
body,
div,
span,
header,
footer,
nav,
section,
aside,
article,
ul,
dl,
dt,
dd,
li,
a,
p,
h1,
h2,
h3,
h4,
h5,
h6,
i,
b,
textarea,
button,
input,
select,
figure,
figcaption {
  list-style: initial;
  padding: revert;
  margin: revert;
}
</style>
